import React, { useState, useEffect, useCallback } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import SettingsIcon from '@mui/icons-material/Settings';

import { ThemeProvider as ThemeProviderV5, createTheme as createThemeV5 } from '@mui/material/styles';
import { ThemeProvider as ThemeProviderV4, createMuiTheme as createThemeV4 } from '@material-ui/core/styles';
import CssBaselineV5 from '@mui/material/CssBaseline';
import CssBaselineV4 from '@material-ui/core/CssBaseline';
import AppBar from '@mui/material/AppBar';
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import EditNoteIcon from '@mui/icons-material/EditNote';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import TaskIcon from '@mui/icons-material/Task';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { useDropzone } from 'react-dropzone';
import {

    FormLabel, FormControl
} from '@mui/material';
import Popover from '@mui/material/Popover';
import { Navigation, Pagination } from "swiper/modules"; // Certifique-se de importar os módulos
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Inventory2Icon from '@mui/icons-material/Inventory2';

import CancelIcon from '@mui/icons-material/Cancel';
import InventoryIcon from '@mui/icons-material/Inventory';
import DiscountIcon from '@mui/icons-material/Discount'; // ou LocalOffer, Percent, etc.
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { Box, Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { Delete } from '@material-ui/icons';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import InfoIcon from '@mui/icons-material/Info';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { styled } from '@material-ui/styles';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import DoneIcon from '@material-ui/icons/Done';
import ChatIcon from '@mui/icons-material/Chat';
import VariationsIcon from '@mui/icons-material/ViewCarousel';
import moment from 'moment';
import miniatura_pdf from '../../../../../assets/imgs/miniatura_pdf.png';
import office from '../../../../../assets/imgs/office.png';
import Notifications from '@mui/icons-material/Notifications';

import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import ReplyIcon from '@mui/icons-material/Reply';

import api from '../../../../../services/api';
import { Popper, ClickAwayListener } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CadastrarPreCotacao from './cadastrarCotacao.js';
import {
    DataGrid, ptBR,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import {
    MaterialReactTable
} from 'material-react-table';

import NavegadorGestao from '../../../../../components/NavBarGestao';
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

import { Card, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';

import { Email, EmailOutlined, Visibility, VisibilityOff, Message, MessageOutlined } from '@mui/icons-material';
import AnaliseOrcamentaria from './analiseOrcamentaria.js';
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import AddBoxIcon from '@mui/icons-material/AddBox';

import ImageIcon from "@mui/icons-material/Image";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import DescriptionIcon from "@mui/icons-material/Description";
import ListAltIcon from "@mui/icons-material/ListAlt";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import RequerimentoInsumos from '../../../../../pages/painelAdmin/AreaGestao/ModuloAdministracao/OrdensDeServicos/requerimentoInsumos.js'


const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'blue',
    },
}));


const ColorButtonBlue = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'blue',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'blue',
        color: 'whit',
        borderColor: 'red',
    },
}));


const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'whit',
        borderColor: 'blue',
    },
}));

const dropzoneStyles = {
    border: '2px dashed #cccccc',
    borderRadius: '4px',
    padding: '20px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '20px 0',
};


export default function EditarOrdemDeCompra() {

    const [isDark, setIsDark] = useState(Cookies.get('darkMode') === 'true');
    const [telaCheia, setTelaCheia] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            const darkMode = Cookies.get('darkMode') === 'true';
            if (darkMode !== isDark) {
                setIsDark(darkMode);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [isDark]);

    const themeV5 = createThemeV5({
        palette: {
            mode: isDark ? 'dark' : 'light',
        },
        zIndex: {
            tooltip: telaCheia ? 11000 : 1500,
            popover: telaCheia ? 11000 : 1500,
            modal: telaCheia ? 11000 : 1300,
            snackbar: telaCheia ? 11000 : 1400,
        }
    });

    const themeV4 = createThemeV4({
        palette: {
            type: isDark ? 'dark' : 'light',
        },
        zIndex: {
            tooltip: telaCheia ? 11000 : 1500,
            popover: telaCheia ? 11000 : 1500,
            modal: telaCheia ? 11000 : 1300,
            snackbar: telaCheia ? 11000 : 1400,
        }
    });


    const { idOrdemCompra } = useParams();
    const [imagemSelecionada1, setImagemSelecionada1] = useState(null);
    const [imagemSelecionada2, setImagemSelecionada2] = useState(null);
    const [imagemSelecionada3, setImagemSelecionada3] = useState(null);
    const [imagemSelecionada4, setImagemSelecionada4] = useState(null);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // <=600px

    const [descricaoImagem1, setDescricaoImagem1] = useState('');
    const [descricaoImagem2, setDescricaoImagem2] = useState('');
    const [descricaoImagem3, setDescricaoImagem3] = useState('');
    const [descricaoImagem4, setDescricaoImagem4] = useState('');

    const [projetoSelecionado, setProjetoSelecionado] = useState(null);
    const [propostaSelecionada, setPropostaSelecionada] = useState(null);

    const onDrop1 = useCallback((acceptedFiles) => {
        // Obtém o arquivo recebido
        const file = acceptedFiles[0];
        if (!file) {
            alert("Nenhum arquivo recebido.");
            return;
        }

        // Converte a imagem para PNG usando Canvas
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;

                // Desenha a imagem no Canvas
                ctx.drawImage(img, 0, 0);

                // Converte o Canvas para PNG
                canvas.toBlob(
                    (blob) => {
                        const convertedFile = new File([blob], `${file.name.split('.')[0]}.png`, { type: "image/png" });
                        setImagemSelecionada1(convertedFile);
                        console.log("Imagem convertida para PNG:", convertedFile);
                    },
                    "image/png",
                    1 // Qualidade máxima
                );
            };
        };
        reader.readAsDataURL(file);
    }, []);

    const onDrop2 = useCallback((acceptedFiles) => {
        // Obtém o arquivo recebido
        const file = acceptedFiles[0];
        if (!file) {
            alert("Nenhum arquivo recebido.");
            return;
        }

        // Converte a imagem para PNG usando Canvas
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;

                // Desenha a imagem no Canvas
                ctx.drawImage(img, 0, 0);

                // Converte o Canvas para PNG
                canvas.toBlob(
                    (blob) => {
                        const convertedFile = new File([blob], `${file.name.split('.')[0]}.png`, { type: "image/png" });
                        setImagemSelecionada2(convertedFile);
                        console.log("Imagem convertida para PNG:", convertedFile);
                    },
                    "image/png",
                    1 // Qualidade máxima
                );
            };
        };
        reader.readAsDataURL(file);
    }, []);

    const onDrop3 = useCallback((acceptedFiles) => {
        // Obtém o arquivo recebido
        const file = acceptedFiles[0];
        if (!file) {
            alert("Nenhum arquivo recebido.");
            return;
        }

        // Converte a imagem para PNG usando Canvas
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;

                // Desenha a imagem no Canvas
                ctx.drawImage(img, 0, 0);

                // Converte o Canvas para PNG
                canvas.toBlob(
                    (blob) => {
                        const convertedFile = new File([blob], `${file.name.split('.')[0]}.png`, { type: "image/png" });
                        setImagemSelecionada3(convertedFile);
                        console.log("Imagem convertida para PNG:", convertedFile);
                    },
                    "image/png",
                    1 // Qualidade máxima
                );
            };
        };
        reader.readAsDataURL(file);
    }, []);

    const onDrop4 = useCallback((acceptedFiles) => {
        // Obtém o arquivo recebido
        const file = acceptedFiles[0];
        if (!file) {
            alert("Nenhum arquivo recebido.");
            return;
        }

        // Converte a imagem para PNG usando Canvas
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;

                // Desenha a imagem no Canvas
                ctx.drawImage(img, 0, 0);

                // Converte o Canvas para PNG
                canvas.toBlob(
                    (blob) => {
                        const convertedFile = new File([blob], `${file.name.split('.')[0]}.png`, { type: "image/png" });
                        setImagemSelecionada4(convertedFile);
                        console.log("Imagem convertida para PNG:", convertedFile);
                    },
                    "image/png",
                    1 // Qualidade máxima
                );
            };
        };
        reader.readAsDataURL(file);
    }, []);



    const { getRootProps: getRootProps1, getInputProps: getInputProps1 } = useDropzone({
        onDrop: onDrop1,

        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: 'image/*', // Restringe a aceitação apenas para arquivos .png
    });

    const { getRootProps: getRootProps2, getInputProps: getInputProps2 } = useDropzone({
        onDrop: onDrop2,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: 'image/*', // Restringe a aceitação apenas para arquivos .png
    });
    const { getRootProps: getRootProps3, getInputProps: getInputProps3 } = useDropzone({
        onDrop: onDrop3,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: 'image/*', // Restringe a aceitação apenas para arquivos .png
    });
    const { getRootProps: getRootProps4, getInputProps: getInputProps4 } = useDropzone({
        onDrop: onDrop4,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: 'image/*', // Restringe a aceitação apenas para arquivos .png
    });



    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const [valueDocs, setValueDocs] = React.useState(0);


    const handleChangeIndexDocs = (index) => {
        setValueDocs(index);
    };


    const [arquivos, setArquivos] = useState(null);


    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [value, setValue] = React.useState(0);

    const [botaoEscolherFaturamentoCliquado, setBotaoEscolherFaturamentoCliquado] = useState(false);

    const [motivoEscolha, setMotivoEscolha] = useState('');

    const [columnsAnalise, setColumnsAnalise] = useState([]);


    const [unidadeSelecionada, setUnidadeSelecionada] = useState(null);



    const handleToggleTelaCheia = () => {
        setTelaCheia(prev => !prev);
    };

    const [idUsuarioLogado, setIdUsuarioLogado] = useState(0);
    const [idUsuarioCriador, setIdUsuarioCriador] = useState(0);


    const [openDialogNovaCotacao, setOpenDialogNovaCotacao] = useState(false);

    function handleCloseDialogNovaCotacao() {
        setOpenDialogNovaCotacao(false);
        listarInformacoes();
    }




    async function baixarArquivo(caminho) {
        try {
            const token = Cookies.get('token');
            const headers = {
                'Authorization': 'Bearer ' + token
            }

            const response = await api.post("/v1/protected/ordensdecompras/baixarPdf", { caminho: encodeURIComponent(caminho) }, {
                headers: headers,
                responseType: 'arraybuffer',  // Indica que a resposta é um array de bytes
            });

            // Cria um blob com os dados recebidos
            const blob = new Blob([response.data], { type: 'application/pdf' });

            // Cria uma URL do blob
            const blobUrl = URL.createObjectURL(blob);

            // Abre uma nova guia com o arquivo PDF
            window.open(blobUrl, '_blank');
        } catch (error) {
            // Trate os erros conforme necessário
            console.log("Erro ao baixar o arquivo: " + error);
        }
    }




    const history = useHistory();

    const [descricao, setDescricao] = useState('');
    const [loading, setLoading] = useState(true);

    const [valorTotalGlobal, setValorTotalGlobal] = useState(0.0);
    const [valorFreteGlobal, setValorFreteGlobal] = useState(0.0);



    const [ordemCompra, setOrdemCompra] = useState(null);
    const [ordemServicoSelecionada, setOrdemServicoSelecionada] = useState(null);

    const [informacoes, setInformacoes] = useState("");

    const [solicitantesSelecionados, setSolicitantesSelecionados] = useState([]);

    const [isSolicitante, setIsSolicitante] = useState(false);
    const [isSupervisor, setIsSupervisor] = useState(false);

    const [autorizou, setAutorizou] = useState(false);

    const [preCotacoes, setPreCotacoes] = useState([]);

    const [objetosAnalise, setObjetosAnalise] = useState([]);
    const [fornecedoresAnalise, setFornecedoresAnalise] = useState([]);

    const [infoOrdem, setInfoOrdem] = useState('');

    const [openAtualizando, setOpenAtualizando] = useState(false);


    const [arquivoSelecionado1, setArquivoSelecionado1] = useState(null);
    const [arquivoSelecionado2, setArquivoSelecionado2] = useState(null);
    const [arquivoSelecionado3, setArquivoSelecionado3] = useState(null);

    const onDropArquivo1 = useCallback((acceptedFiles) => {
        setArquivoSelecionado1(acceptedFiles[0]);
    }, []);

    const onDropArquivo2 = useCallback((acceptedFiles) => {
        setArquivoSelecionado2(acceptedFiles[0]);
    }, []);

    const onDropArquivo3 = useCallback((acceptedFiles) => {
        setArquivoSelecionado3(acceptedFiles[0]);
    }, []);

    const { getRootProps: getRootArquivoProps1, getInputProps: getInputArquivoProps1 } = useDropzone({
        onDrop: onDropArquivo1,
        multiple: false, // Apenas um arquivo
        // accept removido → aceita qualquer tipo
    });

    const { getRootProps: getRootArquivoProps2, getInputProps: getInputArquivoProps2 } = useDropzone({
        onDrop: onDropArquivo2,
        multiple: false,
    });

    const { getRootProps: getRootArquivoProps3, getInputProps: getInputArquivoProps3 } = useDropzone({
        onDrop: onDropArquivo3,
        multiple: false,
    });







    const [imagemZoom, setImagemZoom] = useState(null);

    const [todasImagens, setTodasImagens] = useState([]);
    const [todosDocumentos, setTodosDocumentos] = useState([]);

    async function listarInformacoes() {
        try {


            const token = Cookies.get('token');

            let status_ordem = -1;
            let isSolicitanteLocal = false;

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("/v1/protected/ordensdecompras/ordemdecompra/listarporid/" + idOrdemCompra, {
                headers: headers
            }).then(function (response) {

                console.log("ordem de compra listada!");

                const ordem_compra = response.data.ordem_compra;
                setOrdemCompra(ordem_compra);

                setProjetoSelecionado(response.data.ordem_compra.projeto);
                setPropostaSelecionada(response.data.ordem_compra.proposta);

                // Cria todasImagens já filtrando apenas os caminhos válidos
                const setters = [
                    setDescricaoImagem1,
                    setDescricaoImagem2,
                    setDescricaoImagem3,
                    setDescricaoImagem4,
                ];

                const imagens = [];

                for (let i = 1; i <= 4; i++) {
                    const caminho = ordem_compra[`caminho_imagem${i}`];
                    const descricao = ordem_compra[`descricao_imagem${i}`] || "";

                    // aplica automaticamente no setter correspondente
                    setters[i - 1](descricao);

                    if (caminho && caminho.trim() !== "") {
                        imagens.push({
                            caminho: caminho.replace(
                                "/home/wwgrup/ordensdecompra/",
                                "https://gruporosinetos.com/ocmidias/"
                            ),
                            descricao,
                        });
                    }
                }
                setTodasImagens(imagens); // supondo que você tenha um useState para isso




                // Cria todasImagens já filtrando apenas os caminhos válidos
                const documentos = [];
                for (let i = 1; i <= 3; i++) {
                    const caminho = ordem_compra[`caminho_arquivo${i}`];
                    const descricao = ordem_compra[`descricao_arquivo${i}`] || "";

                    if (caminho && caminho.trim() !== "") {
                        documentos.push({
                            caminho: caminho.replace(
                                "/home/wwgrup/ordensdecompra/",
                                "https://gruporosinetos.com/ocmidias/"
                            ),
                            descricao,
                        });
                    }
                }

                setTodosDocumentos(documentos); // supondo que você tenha um useState para isso


                let text_info0 = ordem_compra.status === 0 ? "Status: Elaborando Cotações" :
                    ordem_compra.status === 1 ? "Status: Em Ánalise Orçamentária" :
                        ordem_compra.status === 2 ? "Status: Aguardando Autorizações" :

                            ordem_compra.status === 3 ? "Status: Ordem Autorizada, em processo de Compra e Faturamento" : '';
                text_info0 += "\n\n";

                let text_info1 = "1) " + ordem_compra.usuario.nome_amigavel + " criou a Ordem em " + moment(ordem_compra.data_criacao).format('HH:mm:ss DD/MM/YYYY')
                let text_info2 = "\n2) " + ordem_compra.usuario.nome_amigavel + " finalizou a elaboração de Cotações em " + moment(ordem_compra.data_usuario_finalizou_pre_cotacoes).format('HH:mm:ss DD/MM/YYYY')

                let text_info3 = "\n\nÁnalise Orçamentária:\n3) ";

                try {
                    text_info3 += (ordem_compra.status >= 2 ?
                        (ordem_compra.usuario_finalizou_analise_orcamentaria.nome_amigavel + " em " + moment(ordem_compra.data_hora_autorizacao).format('HH:mm:ss DD/MM/YYYY') + " finalizou a Ánalise Orçamentária"
                        )
                        : "Ánalise Orçamentária não finalizada");

                } catch (err) {
                    console.error("Erro processando analise orcamentaria:", err);
                }

                let text_info4 = "\n\nValor Total: " + currencyFormatter.format(ordem_compra.valor_total);





                status_ordem = ordem_compra.status;
                console.log("Status ordem: " + status_ordem);
                setOrdemServicoSelecionada(response.data.ordem_compra.ordem_servico);



                setPreCotacoes(response.data.ordem_compra.pre_cotacoes);
                setIdUsuarioCriador(response.data.ordem_compra.usuario.id_usuario);
                setUnidadeSelecionada(response.data.ordem_compra.unidade);

                setDescricao(response.data.ordem_compra.descricao);
                setSolicitantesSelecionados(response.data.ordem_compra.solicitantes);

                let text_info5 = "\n\nAprovações dos Solicitantes:\n";
                try {
                    response.data.ordem_compra.solicitantes.forEach(solicitante => {
                        text_info5 += solicitante.solicitante.nome_amigavel +
                            (solicitante.autorizado === 0
                                ? " ainda não aprovou a Análise Orçamentária"
                                : " aprovou a Análise Orçamentária em " + moment(solicitante.data_hora_autorizacao).format('HH:mm:ss DD/MM/YYYY')) +
                            " (" + solicitante.id_ordem_compra_solicitante + ")\n";

                        if (parseInt(solicitante.solicitante.id_usuario) === parseInt(Cookies.get("id_usuario"))) {
                            setIsSolicitante(true);
                            isSolicitanteLocal = true;
                            if (parseInt(solicitante.autorizado) === 1) {
                                setAutorizou(true);
                            }
                        }
                    });
                } catch (err) {
                    console.error("Erro processando solicitantes:", err);
                }

                let text_info51 = "\n\nAutorizações dos Supervisores:\n";
                try {
                    response.data.ordem_compra.supervisores.forEach(solicitante => {
                        text_info51 += "O supervisor " + solicitante.solicitante.nome_amigavel +
                            (solicitante.autorizado === 0
                                ? " ainda não autorizou a Ordem de Compra (" + solicitante.id_ordem_compra_solicitante + ")"
                                : " autorizou a Ordem de Compra em " + moment(solicitante.data_hora_autorizacao).format('HH:mm:ss DD/MM/YYYY')) +
                            " (" + solicitante.id_ordem_compra_solicitante + ")\n";

                        if (parseInt(solicitante.solicitante.id_usuario) === parseInt(Cookies.get("id_usuario"))) {
                            setIsSupervisor(true);
                            isSolicitanteLocal = true;
                            if (parseInt(solicitante.autorizado) === 1) {
                                setAutorizou(true);
                            }
                        }
                    });
                } catch (err) {
                    console.error("Erro processando supervisores:", err);
                }

                let text_info6 = "\n\nAutorizações da Mesa Diretora:\n";
                try {
                    if (ordem_compra.numero_diretores > 0) {
                        response.data.ordem_compra.diretores.forEach(solicitante => {
                            text_info6 += solicitante.solicitante.nome_amigavel +
                                (solicitante.autorizado === 0
                                    ? " ainda não autorizou a Ordem de Compra (" + solicitante.id_ordem_compra_solicitante + ")"
                                    : " autorizou a Ordem de Compra em " + moment(solicitante.data_hora_autorizacao).format('HH:mm:ss DD/MM/YYYY')) +
                                " (" + solicitante.id_ordem_compra_solicitante + ")\n";

                            if (parseInt(solicitante.solicitante.id_usuario) === parseInt(Cookies.get("id_usuario"))) {
                                setIsSolicitante(true);
                                isSolicitanteLocal = true;
                                if (parseInt(solicitante.autorizado) === 1) {
                                    setAutorizou(true);
                                }
                            }
                        });
                    }
                } catch (err) {
                    console.error("Erro processando diretores:", err);
                }

                try {
                    setInfoOrdem(
                        text_info0 + text_info1 + text_info2 + text_info3 + text_info4 +
                        text_info5 + text_info51 + text_info6
                    );
                } catch (err) {
                    console.error("Erro ao setar infoOrdem:", err);
                }






                // setArquivos(response.data);

                api.get("/v1/protected/ordensdecompras/ordemdecompra/analiseorcamentaria/" + idOrdemCompra, {
                    headers: headers
                }).then(function (response_analise) {

                    const objetosAnaliseLocal = response_analise.data.itens;

                    const total_itens = objetosAnaliseLocal.length;

                    const tam = parseInt(response_analise.data.quantidade_fornecedores);

                    setValorTotalGlobal(response_analise.data.valor_total_global);
                    setValorFreteGlobal(response_analise.data.valor_total_frete_global);

                    const columns = [
                        {
                            accessorKey: 'id_item_analise',
                            header: 'ID',
                            size: 50,
                            maxWidth: 50,
                            Cell: ({ cell }) => (
                                <span style={{ fontSize: 12, color: 'blue' }}>
                                    {cell.getValue()}
                                </span>
                            ),
                        },
                        {
                            header: 'Descrição',
                            size: 500,
                            accessorFn: row => {
                                return {
                                    insumo: row.insumo,

                                };

                            },
                            Cell: ({ renderedCellValue }) => {
                                const processarTextoComQuebraDeLinha = (insumo) => {
                                    let textoComQuebraDeLinha = "Descrição Principal: " + insumo.descricao + "\n\n";

                                    if (insumo.variacoes && insumo.variacoes.length > 0) {
                                        console.log("tem variacoes");
                                        textoComQuebraDeLinha += insumo.variacoes
                                            .map((variacao, index) => (
                                                `Fornecedor: ${variacao.nome_amigavel_fornecedor} Variação: ${variacao.descricao}${index !== insumo.variacoes.length - 1 ? '\n' : ''}`
                                            )).join('');
                                        return textoComQuebraDeLinha; // Retorna o texto processado apenas se houver variações
                                    } else {
                                        console.log("nao tem variacoes");
                                        return null; // Se não houver variações, retorne null
                                    }
                                };

                                const textoComQuebraDeLinha = processarTextoComQuebraDeLinha(renderedCellValue.insumo);

                                if (textoComQuebraDeLinha) {
                                    return (
                                        <Tooltip
                                            title={
                                                <div style={{ backgroundColor: isDark ? '#1E1E1E' : 'white', color: isDark ? 'white' : 'black', size: 14, minHeight: '50px', minWidth: '400px', border: isDark ? '2px solid #555' : '2px solid black' }}>
                                                    <span>
                                                        {textoComQuebraDeLinha.split('\n').map((line, index) => (
                                                            <React.Fragment key={index}>
                                                                {line}
                                                                <br />
                                                            </React.Fragment>
                                                        ))}
                                                    </span>
                                                </div>
                                            }
                                            placement="top"
                                            arrow
                                            style={{ backgroundColor: isDark ? '#1E1E1E' : 'white' }}
                                            sx={{ backgroundColor: isDark ? '#1E1E1E' : 'white' }}
                                        >
                                            <span>{renderedCellValue.insumo.descricao}</span>
                                            <VariationsIcon />
                                        </Tooltip>
                                    );
                                } else {
                                    return <span>{renderedCellValue.insumo.descricao}</span>;
                                }
                            }
                        },
                        {
                            accessorKey: 'quantidade',
                            header: 'Quantidade',
                            size: 25,
                            maxWidth: 25,
                            Cell: ({ cell }) => (
                                <span style={{ fontSize: 14, color: isDark ? 'white' : 'black', fontWeight: 'bold' }}>
                                    {cell.getValue()}
                                </span>
                            ),
                        },

                    ];

                    for (let i = 0; i < tam; i++) {
                        const fornecedorNome = response_analise.data.nome_fornecedores[i];
                        const fornecedorNomeCurto = fornecedorNome.length > 20
                            ? fornecedorNome.slice(0, 20) + '...'
                            : fornecedorNome
                        const id_fornecedor = response_analise.data.ids_fornecedores[i];
                        const valor_total_por_fornecedor = response_analise.data.valores_totais[i];
                        const valor_desconto_geral_por_fornecedor = response_analise.data.valores_desconto[i];

                        const valor_total_selecionado_por_fornecedor = response_analise.data.valores_totais_selecionados[i];
                        const valor_frete_por_fornecedor = response_analise.data.valores_fretes[i];
                        const preCotacaoSelecionada = response_analise.data.cotacoes[i].selecionado;
                        const idPreCotacao = response_analise.data.cotacoes[i].id_pre_cotacao;

                        const valor_frete__se_1_item_selecionadopor_fornecedor = response_analise.data.valores_fretes_se_1_item_selecionado[i];
                        const quantidade_itens_por_fornecedor = response_analise.data.quantidade_itens_por_fornecedor[i];

                        const docie_fornecedor = response_analise.data.docie_fornecedores[i];
                        const quantidade_compras_historico = docie_fornecedor ? docie_fornecedor.quantidade_compras : 0;
                        const valor_total_compras_historico = docie_fornecedor ? docie_fornecedor.valor_total_compras : 0;
                        const url_arquivo_pre_cotacao = docie_fornecedor ? docie_fornecedor.url_arquivo : "";




                        console.log("id: " + id_fornecedor);
                        console.log("valor total por forncedor: " + valor_total_por_fornecedor);

                        columns.push(
                            {
                                id: `fornecedor${i + 1}`,
                                header: `${fornecedorNomeCurto}`,
                                size: 210,
                                maxWidth: 210,
                                Header: (
                                    <Tooltip
                                        title={
                                            <div style={{ backgroundColor: isDark ? '#333' : 'white', fontSize: 14, color: isDark ? 'white' : 'black', width: '200px' }}>
                                                <Grid
                                                    item xs={12}
                                                    container
                                                    direction="row"
                                                    alignItems="center"
                                                    justifyContent={"center"}
                                                >
                                                    <Grid
                                                        item xs={12}
                                                        container
                                                        direction="row"
                                                        alignItems="center"
                                                        justifyContent={"center"}
                                                    >

                                                        <IconButton
                                                            component="a"
                                                            href={`/gestao/operacional/almoxarifado/fornecedores/gerenciarfornecedor/${id_fornecedor}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            size="small"
                                                        >
                                                            <SettingsIcon fontSize="small" sx={{ color: isDark ? '#fff' : 'inherit' }} >
                                                                Ver fornecedor
                                                            </SettingsIcon>
                                                        </IconButton>
                                                        {
                                                            url_arquivo_pre_cotacao ? (
                                                                <div
                                                                    onClick={() => {
                                                                        const link = url_arquivo_pre_cotacao.replaceAll(
                                                                            "/home/wwgrup/ordensdecompra/",
                                                                            "https://gruporosinetos.com/ocmidias/"
                                                                        );
                                                                        window.open(link, "_blank", "noopener,noreferrer");
                                                                    }}
                                                                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '30px', height: '30px' }}
                                                                >
                                                                    {url_arquivo_pre_cotacao.toLowerCase().endsWith('.pdf') ? (
                                                                        <img alt={'miniatura_pdf'} style={{ textAlign: 'center' }} src={miniatura_pdf} />
                                                                    ) : (
                                                                        <img alt={'office'} style={{ textAlign: 'center' }} src={office} />
                                                                    )}

                                                                </div>
                                                            ) : (
                                                                <div >

                                                                </div>
                                                            )
                                                        }


                                                        <span style={{ padding: 20, color: isDark ? 'white' : 'black' }}>
                                                            {"Este fornecedor tem " + quantidade_itens_por_fornecedor + " de " + total_itens + " itens requeridos"}
                                                        </span>


                                                        <span style={{ padding: 20, color: isDark ? 'white' : 'black' }}>
                                                            Historico de compras
                                                        </span>
                                                        <div style={{ fontSize: 14, color: isDark ? 'white' : 'black' }}>
                                                            {quantidade_compras_historico} compras | {currencyFormatter.format(valor_total_compras_historico)}
                                                        </div>



                                                    </Grid>
                                                </Grid>
                                            </ div>
                                        }
                                        placement='bottom-start'
                                        arrow
                                        style={{ backgroundColor: isDark ? '#333' : 'white', color: isDark ? 'white' : 'black' }}
                                    >
                                        <Grid
                                            item xs={12}
                                            container
                                            direction="row"
                                            alignItems="center"
                                            justifyContent={"center"}
                                        >

                                            <Grid
                                                item xs={6}
                                                container
                                                direction="column"
                                                alignItems="flex-end"
                                                justifyContent={"center"}
                                            >

                                                <span style={{ fontSize: 12, wordWrap: 'break-word', display: 'inline-block', color: isDark ? 'white' : 'black' }}>
                                                    {fornecedorNomeCurto}
                                                </span>


                                            </Grid>

                                            <Grid
                                                item xs={1}
                                                container
                                                direction="row"
                                                alignItems="center"
                                                justifyContent={"flex-start"}
                                            >
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={preCotacaoSelecionada === 1}

                                                            onChange={(e) => {
                                                                handleChangePreCotacaoSelected(idPreCotacao)
                                                            }}
                                                            disabled={
                                                                !(parseInt(status_ordem) <= 10)
                                                            }

                                                            inputProps={{ 'aria-label': 'controlled' }}

                                                        />
                                                    }
                                                    label=""
                                                />

                                            </Grid>

                                        </Grid>
                                    </Tooltip>

                                ),

                                columns: [
                                    {
                                        accessorFn: row => {
                                            const cotacao = row.fornecedor_insumo[i];
                                            if (cotacao) {
                                                return {
                                                    valor_unitario: cotacao.valor_unitario,
                                                    valor_desconto: cotacao.valor_desconto,
                                                    descricao_cotacao: cotacao.descricao,
                                                    observacoes: cotacao.observacoes,
                                                    link: cotacao.link,
                                                    cotacao: cotacao,
                                                };
                                            } else {
                                                return {
                                                    valor_unitario: 0.0,
                                                    valor_desconto: 0.0,
                                                    descricao_cotacao: "",
                                                    observacoes: "",
                                                    link: "",
                                                    descricao_insumo: "",
                                                    cotacao: null,
                                                };
                                            }
                                        },
                                        id: `valor_unitario${i + 1}`,
                                        header: 'Valor Unitário',
                                        size: 130,
                                        maxHeight: 130,
                                        Cell: ({ renderedCellValue }) => {

                                            if (renderedCellValue.valor_unitario > 0.0) {
                                                return (
                                                    <Tooltip
                                                        title={
                                                            <div style={{ backgroundColor: isDark ? '#333' : 'white', fontSize: 14, color: isDark ? 'white' : 'black', padding: 5, maxWidth: '400px', minWidth: '200px' }}>
                                                                <div style={{ backgroundColor: isDark ? '#333' : 'white', fontSize: 14, color: isDark ? 'white' : 'black' }}>Descrição da Cotação: {renderedCellValue.descricao_cotacao}</div>
                                                                <div style={{ backgroundColor: isDark ? '#333' : 'white', fontSize: 14, color: isDark ? 'white' : 'black' }} >Observações do Insumo: {renderedCellValue.observacoes}</div>
                                                                <br />
                                                                <div style={{ backgroundColor: isDark ? '#333' : 'white', fontSize: 14, color: isDark ? 'white' : 'black' }}>Valor Inicial: {currencyFormatter.format(renderedCellValue.valor_unitario)}</div>
                                                                <div style={{ backgroundColor: isDark ? '#333' : 'white', fontSize: 14, color: isDark ? 'white' : 'black' }}>Desconto: {currencyFormatter.format(renderedCellValue.valor_desconto)}</div>
                                                                <br />
                                                                <div style={{ backgroundColor: isDark ? '#333' : 'white', fontSize: 14, color: isDark ? 'white' : 'black' }}>Valor com Desconto: {currencyFormatter.format(renderedCellValue.valor_unitario - renderedCellValue.valor_desconto)}</div>
                                                                <br />
                                                                <div style={{ backgroundColor: isDark ? '#333' : 'white', fontSize: 14, color: isDark ? 'white' : 'black' }}>Valor Final: {currencyFormatter.format(renderedCellValue.valor_unitario - renderedCellValue.valor_desconto)}</div>

                                                                {renderedCellValue.link && <div><a href={renderedCellValue.link} target="_blank" rel="noopener noreferrer" style={{ backgroundColor: isDark ? '#1E1E1E' : 'white', fontSize: 14, color: 'blue' }}>Acessar</a></div>}

                                                                <Grid item xs={12} style={{ paddingTop: 50 }}>
                                                                    <Grid item xs={12}>
                                                                        <Typography variant="h7" >Tarefas</Typography>
                                                                    </Grid>
                                                                    {renderedCellValue.cotacao.tarefas?.map((tarefa, index) => (

                                                                        <Grid item xs={12} key={index}>
                                                                            {/* xs=12 para dispositivos pequenos, sm=6 para médios, md=4 para grandes, lg=3 para extra grandes */}
                                                                            <Card style={{ borderRadius: '10px', border: '1px solid #e0e0e0', boxShadow: '0 10px 20px rgba(0, 0, 0, 0.2)', marginBottom: '3px' }}>
                                                                                <CardContent>

                                                                                    <Typography variant="h6" style={{ fontSize: 12 }}>{tarefa.nome}</Typography>
                                                                                    <br />
                                                                                    <Tooltip
                                                                                        title={
                                                                                            <span> {tarefa.vizualizada === 0 ? (tarefa.usuario_destinado.nome_amigavel + " ainda não vizualizou esta tarefa") : (tarefa.usuario_destinado.nome_amigavel + " vizualizou esta tarefa")}</span>
                                                                                        }
                                                                                        placement='top-start'
                                                                                        arrow
                                                                                        style={{ backgroundColor: isDark ? '#333' : 'white', color: isDark ? 'white' : 'black' }}
                                                                                    >
                                                                                        {tarefa.vizualizada === 0 ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                                                                                    </Tooltip>

                                                                                    <Tooltip
                                                                                        title={
                                                                                            <span> {tarefa.status === 0 ? (tarefa.usuario_destinado.nome_amigavel + " ainda não executou esta tarefa") : (tarefa.usuario_destinado.nome_amigavel + " executou esta tarefa, verifique a mensagem de resposta!")}</span>
                                                                                        }
                                                                                        placement='top-start'
                                                                                        arrow
                                                                                        style={{ backgroundColor: isDark ? '#333' : 'white', color: isDark ? 'white' : 'black' }}
                                                                                    >
                                                                                        {tarefa.status === 0 ? <CloseIcon fontSize="small" /> : <CheckCircleIcon fontSize="small" />}
                                                                                    </Tooltip>

                                                                                    <br />
                                                                                    <br />
                                                                                    <Tooltip
                                                                                        title={
                                                                                            <div style={{ backgroundColor: isDark ? '#333' : 'white', fontSize: 14, color: isDark ? 'white' : 'black', padding: 5, maxWidth: '400px', maxHeight: '100px' }}>
                                                                                                <span style={{ backgroundColor: 'rgba(0, 0, 0, 0)' }}>{tarefa.mensagem}</span>

                                                                                            </div>
                                                                                        }
                                                                                        placement='left'
                                                                                        arrow
                                                                                        style={{ backgroundColor: isDark ? '#333' : 'white', color: isDark ? 'white' : 'black' }}
                                                                                    >
                                                                                        <span style={{ backgroundColor: isDark ? '#333' : 'white', color: isDark ? 'white' : 'black' }}>{"Mensagem"}</span>
                                                                                        {
                                                                                            tarefa && tarefa.status === 0 && (parseInt(Cookies.get("id_usuario")) === parseInt(tarefa.usuario_destinado.id_usuario)) &&
                                                                                            <IconButton
                                                                                                color="primary"
                                                                                                aria-label="Responder"
                                                                                                onClick={(e) => openModalResposta(tarefa)}

                                                                                            >
                                                                                                <ReplyIcon />
                                                                                            </IconButton >
                                                                                        }

                                                                                    </Tooltip>
                                                                                    <br />
                                                                                    <Tooltip
                                                                                        title={

                                                                                            <div style={{ backgroundColor: isDark ? '#333' : 'white', fontSize: 14, color: isDark ? 'white' : 'black', padding: 5, maxWidth: '400px', maxHeight: '100px' }}>
                                                                                                <span style={{ backgroundColor: 'rgba(0, 0, 0, 0)' }}>{tarefa.resposta}</span>

                                                                                            </div>}
                                                                                        placement='left'
                                                                                        arrow
                                                                                        style={{ backgroundColor: isDark ? '#333' : 'white', color: isDark ? 'white' : 'black' }}
                                                                                    >
                                                                                        <span>{"Resposta"}</span>

                                                                                    </Tooltip>



                                                                                </CardContent>
                                                                            </Card>

                                                                        </Grid>
                                                                    ))}
                                                                </Grid>

                                                                <Tooltip
                                                                    title={"Nova Tarefa"
                                                                    }
                                                                    placement='top-start'
                                                                    arrow
                                                                    style={{ backgroundColor: isDark ? '#333' : 'white', color: isDark ? 'white' : 'blue' }}
                                                                >
                                                                    <IconButton
                                                                        color="primary"
                                                                        aria-label="Nova Tarefa"
                                                                        onClick={(e) => renderedCellValue.valor_unitario > 0.0 ? openModal(renderedCellValue.cotacao) : openModal(null)}
                                                                    >
                                                                        <AddIcon />
                                                                    </IconButton>
                                                                </Tooltip>


                                                            </div>
                                                        }
                                                        placement="top"
                                                        arrow
                                                        style={{ backgroundColor: isDark ? '#333' : 'white', color: isDark ? 'white' : 'black' }}
                                                    >


                                                        <span
                                                            style={{
                                                                maxWidth: '130px',
                                                                wordWrap: 'break-word',
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                color: isDark ? 'white' : '#333333',
                                                                gap: '4px',
                                                            }}
                                                        >
                                                            {renderedCellValue.valor_unitario > 0.0
                                                                ? currencyFormatter.format(
                                                                    renderedCellValue.valor_unitario - renderedCellValue.valor_desconto
                                                                )
                                                                : '---'}

                                                            {/* 🔹 Ícone aparece apenas se houver desconto */}
                                                            {renderedCellValue.valor_desconto > 0 && (
                                                                <DiscountIcon
                                                                    style={{
                                                                        color: '#4caf50', // verde indicando desconto
                                                                        fontSize: '16px',
                                                                    }}
                                                                />
                                                            )}
                                                        </span>

                                                        {/*
                                                        {renderedCellValue.cotacao.tarefas.length > 0 ? (
                                                            <ChatIcon
                                                                className={renderedCellValue.cotacao.tarefas.some(tarefa => tarefa.status === 0) ? "shake-bell" : ""}
                                                                style={{ color: "green" }}
                                                                sx={{ fontSize: 15, color: 'green' }}
                                                            />
                                                        ) : null}
                                                        */}

                                                    </Tooltip>);
                                            }
                                            else {
                                                return (
                                                    <span style={{ maxWidth: '130px', wordWrap: 'break-word', display: 'inline-block', color: isDark ? 'white' : '#333333' }}>
                                                        {"---"}
                                                    </span>

                                                );
                                            }
                                        },
                                    },
                                    {
                                        accessorFn: row => {
                                            const cotacao = row.fornecedor_insumo[i];
                                            const item = row.fornecedor_insumo2[i];


                                            if (cotacao)
                                                return {
                                                    valor_parcial: (cotacao.valor_unitario - cotacao.valor_desconto) * row.quantidade,
                                                    selecionado: item.selecionado,
                                                    id_item_ordem_compra: item.id_item_ordem_compra,
                                                }
                                            else
                                                return {
                                                    valor_parcial: 0.0,
                                                    selecionado: 0,
                                                    id_cotacao: cotacao.id_cotacao,
                                                }
                                        },
                                        Footer: () => (
                                            <Stack style={{ color: isDark ? 'white' : 'black', backgroundColor: isDark ? '#333' : 'white', fontWeight: 'initial', fontSize: 16 }}>
                                                <Tooltip
                                                    title={
                                                        <div
                                                            style={{ backgroundColor: isDark ? '#333' : 'white', border: isDark ? '2px solid white' : '2px solid black', color: isDark ? 'white' : 'black', padding: 20 }}
                                                        > Valor Itens:
                                                            <Box>
                                                                {currencyFormatter.format(valor_total_por_fornecedor)}
                                                            </Box>
                                                            <br></br>
                                                            Desconto Geral:
                                                            <Box>
                                                                {currencyFormatter.format(valor_desconto_geral_por_fornecedor)}
                                                            </Box>
                                                            <br></br>
                                                            Valor Frete:
                                                            <Box>
                                                                {currencyFormatter.format(valor_frete_por_fornecedor)}
                                                            </Box>

                                                        </div>
                                                    }
                                                    placement="top"
                                                    arrow
                                                    style={{ backgroundColor: isDark ? '#333' : 'white' }}
                                                    sx={{ backgroundColor: isDark ? '#333' : 'white' }}
                                                >
                                                    Valor Total:
                                                    <Box>
                                                        {currencyFormatter.format(valor_total_por_fornecedor + valor_frete_por_fornecedor - valor_desconto_geral_por_fornecedor)}
                                                    </Box>
                                                </Tooltip>





                                                <br></br><br></br>

                                                <Tooltip
                                                    title={
                                                        <div
                                                            style={{ backgroundColor: isDark ? '#333' : 'white', border: isDark ? '2px solid white' : '2px solid black', color: isDark ? 'white' : 'black', padding: 20 }}
                                                        >
                                                            Valor Itens Selecionados:
                                                            <Box>
                                                                {currencyFormatter.format(valor_total_selecionado_por_fornecedor)}
                                                            </Box>
                                                            <br></br>
                                                            Valor Frete:
                                                            <Box>
                                                                {currencyFormatter.format(valor_frete__se_1_item_selecionadopor_fornecedor)}
                                                            </Box>

                                                        </div>
                                                    }
                                                    placement="top"
                                                    arrow
                                                    style={{ backgroundColor: isDark ? '#333' : 'white' }}
                                                    sx={{ backgroundColor: isDark ? '#333' : 'white' }}
                                                >
                                                    Valor Total de Itens Selecionados:
                                                    <Box>
                                                        {currencyFormatter.format(valor_total_selecionado_por_fornecedor + valor_frete__se_1_item_selecionadopor_fornecedor)}
                                                    </Box>
                                                </Tooltip>





                                            </Stack>
                                        ),
                                        id: `valor_total${i + 1}`,
                                        header: 'Valor Total',
                                        size: 160,
                                        maxWidth: 160,
                                        Cell: ({ renderedCellValue }) => (

                                            <Grid
                                                item xs={12}
                                                container
                                                direction="row"
                                                alignItems="center"
                                                justifyContent={"center"}
                                            >

                                                <Grid
                                                    item xs={6}
                                                    container
                                                    direction="row"
                                                    alignItems="center"
                                                    justifyContent={"flex-end"}
                                                >

                                                    <span style={{ wordWrap: 'break-word', display: 'inline-block', color: isDark ? 'white' : 'black' }}>
                                                        {renderedCellValue.valor_parcial > 0.0 ? currencyFormatter.format(renderedCellValue.valor_parcial) : "---"}
                                                    </span>
                                                </Grid>

                                                <Grid
                                                    item xs={1}
                                                    container
                                                    direction="row"
                                                    alignItems="center"
                                                    justifyContent={"flex-start"}
                                                >
                                                    {renderedCellValue.valor_parcial > 0.0 &&
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={renderedCellValue.selecionado === 1}
                                                                    onChange={(e) => {
                                                                        handleChangeSelected(renderedCellValue.id_item_ordem_compra);
                                                                        e.target.checked = renderedCellValue.selecionado === 0; // Define imediatamente o estado do Checkbox para o valor oposto
                                                                    }}
                                                                    disabled={
                                                                        !(parseInt(status_ordem) <= 10)
                                                                    }
                                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                                />
                                                            }
                                                            label=""
                                                        />
                                                    }

                                                </Grid>
                                            </Grid>






                                        ),
                                    },
                                ],
                            }
                        );
                    }




                    setObjetosAnalise(objetosAnaliseLocal);
                    setColumnsAnalise(columns);



                    setLoading(false);
                });
            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }





    async function listarInformacoesSimples() {
        try {


            const token = Cookies.get('token');

            let status_ordem = -1;
            let isSolicitanteLocal = false;

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("/v1/protected/ordensdecompras/ordemdecompra/listarporid/" + idOrdemCompra, {
                headers: headers
            }).then(function (response) {

                console.log("ordem de compra listada!");

                const ordem_compra = response.data.ordem_compra;
                setOrdemCompra(ordem_compra);

                setProjetoSelecionado(response.data.ordem_compra.projeto);
                setPropostaSelecionada(response.data.ordem_compra.proposta);

            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }

    const [descricaoArquivo1, setDescricaoArquivo1] = useState('');
    const [descricaoArquivo2, setDescricaoArquivo2] = useState('');
    const [descricaoArquivo3, setDescricaoArquivo3] = useState('');



    async function atualizarDocumentos() {
        try {
            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token"),
                'Content-Type': 'multipart/form-data'
            };

            const formData = new FormData();

            const arquivos = [arquivoSelecionado1, arquivoSelecionado2, arquivoSelecionado3];

            arquivos.forEach((arc, index) => {
                if (arc) {
                    formData.append('arquivos', arc);
                } else {
                    // envia um arquivo vazio só pra manter o índice
                    formData.append('arquivos', new Blob([]), "vazio" + index);
                }
            });

            if (descricaoArquivo1) formData.append('descricao_arquivo1', descricaoArquivo1);
            if (descricaoArquivo2) formData.append('descricao_arquivo2', descricaoArquivo2);
            if (descricaoArquivo3) formData.append('descricao_arquivo3', descricaoArquivo3);


            formData.append("id_ordem_compra", idOrdemCompra);

            // 🔹 Chamada para o PUT de atualização
            const response = await api.put(
                `/v1/protected/ordensdecompras/ordemdecompra/atualizardocumentos`,
                formData,
                { headers }
            );

            if (response.data) {
                alert("Documentos atualizados com sucesso!");
                listarInformacoesSimples(); // 🔹 Atualiza a tela
            } else {
                alert("Erro ao atualizar documentos.");
            }

        } catch (err) {
            console.error("Erro ao atualizar arquivos:", err);
            alert("Erro de conexão, tente novamente mais tarde.");
        }
    }




    async function handleRemoverImagem(indice) {
        try {
            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token"),
                'Content-Type': 'multipart/form-data'
            };




            // 🔹 Chamada para o PUT de atualização
            const response = await api.put(
                `/v1/protected/ordensdecompras/ordemdecompra/removerimagem/` + idOrdemCompra + "/" + indice,

                { headers }
            );

            if (response.data) {
                listarInformacoes();
            } else {
                alert("Erro ao remover imagem");
            }

        } catch (err) {
            console.error("Erro ao remover imagem:", err);
            alert("Erro de conexão, tente novamente mais tarde.");
        }
    }



    async function atualizarArquivos() {
        try {
            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token"),
                'Content-Type': 'multipart/form-data'
            };

            const formData = new FormData();

            const imagens = [imagemSelecionada1, imagemSelecionada2, imagemSelecionada3, imagemSelecionada4];

            imagens.forEach((img, index) => {
                if (img) {
                    formData.append('imagens', img);
                } else {
                    // envia um arquivo vazio só pra manter o índice
                    formData.append('imagens', new Blob([]), "vazio" + index);
                }
            });

            if (descricaoImagem1) formData.append('descricao_imagem1', descricaoImagem1);
            if (descricaoImagem2) formData.append('descricao_imagem2', descricaoImagem2);
            if (descricaoImagem3) formData.append('descricao_imagem3', descricaoImagem3);
            if (descricaoImagem4) formData.append('descricao_imagem4', descricaoImagem4);


            formData.append("id_ordem_compra", idOrdemCompra);

            // 🔹 Chamada para o PUT de atualização
            const response = await api.put(
                `/v1/protected/ordensdecompras/ordemdecompra/atualizararquivos`,
                formData,
                { headers }
            );

            if (response.data) {
                alert("Arquivos atualizados com sucesso!");
                listarInformacoesSimples(); // 🔹 Atualiza a tela
            } else {
                alert("Erro ao atualizar arquivos.");
            }

        } catch (err) {
            console.error("Erro ao atualizar arquivos:", err);
            alert("Erro de conexão, tente novamente mais tarde.");
        }
    }

    const [loadingAtualizarCompras, setLoadingAtualizarCompras] = useState(false);



    async function atualizarCompras() {
        try {
            setLoadingAtualizarCompras(true); // 🔒 bloqueia a tela

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token"),
            };

            const response = await api.get(
                `/v1/protected/ordensdecompras/ordemdecompra/gerarpdf/` + idOrdemCompra,
                { headers }
            );

            if (response.data) {
                alert("Compras Atualizadas");
            } else {
                alert("Erro ao atualizar as compras, contate o administrador do sistema");
            }

        } catch (err) {
            console.error("Erro ao atualizar arquivos:", err);
            alert("Erro de conexão, tente novamente mais tarde.");
        } finally {
            setLoadingAtualizarCompras(false); // 🔓 libera a tela
        }
    }


    async function recalcular() {
        try {
            const token = Cookies.get('token');
            let status_ordem = -1; // Mantendo como no original

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            // Primeiro obtemos os dados da ordem para ter o status atual
            await api.get("/v1/protected/ordensdecompras/ordemdecompra/listarporid/" + idOrdemCompra, {
                headers: headers
            }).then(function (response) {
                const ordem_compra = response.data.ordem_compra;
                setOrdemCompra(response.data.ordem_compra);
                status_ordem = ordem_compra.status; // Atualiza o status como no original

                // Agora fazemos a requisição da análise orçamentária
                api.get("/v1/protected/ordensdecompras/ordemdecompra/analiseorcamentaria/" + idOrdemCompra, {
                    headers: headers
                }).then(function (response_analise) {
                    const objetosAnaliseLocal = response_analise.data.itens;
                    const total_itens = objetosAnaliseLocal.length;
                    const tam = parseInt(response_analise.data.quantidade_fornecedores);

                    setValorTotalGlobal(response_analise.data.valor_total_global);
                    setValorFreteGlobal(response_analise.data.valor_total_frete_global);

                    const columns = [
                        {
                            accessorKey: 'id_item_analise',
                            header: 'ID',
                            size: 50,
                            maxWidth: 50,
                            Cell: ({ cell }) => (
                                <span style={{ fontSize: 12, color: 'blue' }}>
                                    {cell.getValue()}
                                </span>
                            ),
                        },
                        {
                            header: 'Descrição',

                            size: 500,
                            accessorFn: row => {
                                return {
                                    insumo: row.insumo,
                                };
                            },
                            Cell: ({ renderedCellValue }) => {
                                const processarTextoComQuebraDeLinha = (insumo) => {
                                    let textoComQuebraDeLinha = "Descrição Principal: " + insumo.descricao + "\n\n";
                                    if (insumo.variacoes && insumo.variacoes.length > 0) {
                                        textoComQuebraDeLinha += insumo.variacoes
                                            .map((variacao, index) => (
                                                `Fornecedor: ${variacao.nome_amigavel_fornecedor} Variação: ${variacao.descricao}${index !== insumo.variacoes.length - 1 ? '\n' : ''}`
                                            )).join('');
                                        return textoComQuebraDeLinha;
                                    } else {
                                        return null;
                                    }
                                };

                                const textoComQuebraDeLinha = processarTextoComQuebraDeLinha(renderedCellValue.insumo);
                                if (textoComQuebraDeLinha) {
                                    return (
                                        <Tooltip
                                            title={
                                                <Box sx={{ bgcolor: 'background.paper', color: 'text.primary', p: 1, minWidth: '400px', border: 1, borderColor: 'divider' }}>
                                                    <span>
                                                        {textoComQuebraDeLinha.split('\n').map((line, index) => (
                                                            <React.Fragment key={index}>
                                                                {line}
                                                                <br />
                                                            </React.Fragment>
                                                        ))}
                                                    </span>
                                                </Box>
                                            }
                                            placement="top"
                                            arrow
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        bgcolor: 'background.paper',
                                                        color: 'text.primary',
                                                        border: 1,
                                                        borderColor: 'divider',
                                                        '& .MuiTooltip-arrow': {
                                                            color: 'background.paper',
                                                        }
                                                    }
                                                }
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <span>{renderedCellValue.insumo.descricao}</span>
                                                <VariationsIcon fontSize="small" />
                                            </Box>
                                        </Tooltip>
                                    );

                                } else {
                                    return <span>{renderedCellValue.insumo.descricao}</span>;
                                }
                            }
                        },
                        {
                            accessorKey: 'quantidade',
                            header: 'Quantidade',
                            size: 25,
                            maxWidth: 25,
                            Cell: ({ cell }) => (
                                <Box sx={{ fontSize: 14, color: 'text.primary', fontWeight: 'bold' }}>
                                    {cell.getValue()}
                                </Box>

                            ),
                        },
                    ];

                    for (let i = 0; i < tam; i++) {
                        const fornecedorNome = response_analise.data.nome_fornecedores[i];
                        const docie = response_analise.data.docie_fornecedores[i];
                        const fornecedorNomeCurto = fornecedorNome.length > 20
                            ? fornecedorNome.slice(0, 20) + '...'
                            : fornecedorNome
                        const valor_total_por_fornecedor = response_analise.data.valores_totais[i];
                        const valor_desconto_geral_por_fornecedor = response_analise.data.valores_desconto[i];
                        const valor_total_selecionado_por_fornecedor = response_analise.data.valores_totais_selecionados[i];
                        const valor_frete_por_fornecedor = response_analise.data.valores_fretes[i];
                        const preCotacaoSelecionada = response_analise.data.cotacoes[i].selecionado;
                        const idPreCotacao = response_analise.data.cotacoes[i].id_pre_cotacao;
                        const valor_frete__se_1_item_selecionadopor_fornecedor = response_analise.data.valores_fretes_se_1_item_selecionado[i];
                        const quantidade_itens_por_fornecedor = response_analise.data.quantidade_itens_por_fornecedor[i];


                        console.log("valor total por fornecedor: " + valor_total_por_fornecedor);

                        columns.push({
                            id: `fornecedor${i + 1}`,
                            header: fornecedorNomeCurto,
                            size: 210,
                            maxSize: 210,


                            muiTableHeadCellProps: {
                                sx: {
                                    '& .Mui-TableHeadCell-Content': {
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                    },
                                    '& .MuiTableHeadCell-Content-Wrapper': {
                                        width: '100%',
                                    },
                                    p: 0,
                                },
                            },

                            Header: (
                                <Tooltip
                                    placement="bottom-start"
                                    arrow
                                    PopperProps={{
                                        modifiers: [
                                            {
                                                name: 'preventOverflow',
                                                options: { boundary: 'window' },
                                            },
                                        ],
                                    }}
                                    componentsProps={{
                                        tooltip: {
                                            sx: {
                                                bgcolor: 'background.paper',
                                                color: 'text.primary',
                                                boxShadow: 3,
                                                borderRadius: 2,
                                                p: 2,
                                                minWidth: 280,
                                                maxWidth: 400,
                                                border: 1,
                                                borderColor: 'divider',
                                                '& .MuiTooltip-arrow': {
                                                    color: 'background.paper',
                                                }
                                            },

                                        },
                                    }}
                                    title={
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.2 }}>

                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Inventory2Icon sx={{ fontSize: 18, color: 'primary.main' }} />
                                                <Typography variant="body2">
                                                    {quantidade_itens_por_fornecedor} de {total_itens} itens
                                                </Typography>
                                            </Box>

                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <ShoppingCartIcon sx={{ fontSize: 18, color: 'info.main' }} />
                                                <Typography variant="body2">
                                                    {docie?.quantidade_compras ?? 0} ordens
                                                </Typography>
                                            </Box>

                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <AttachMoneyIcon sx={{ fontSize: 18, color: 'success.main' }} />
                                                <Typography variant="body2" fontWeight={600}>
                                                    {(docie?.valor_total_compras ?? 0).toLocaleString('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL',
                                                    })}
                                                </Typography>
                                            </Box>

                                        </Box>
                                    }
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            width: '100%',
                                            gap: 0.5,
                                        }}
                                    >
                                        {/* Nome */}
                                        <Box
                                            sx={{
                                                flex: 1,
                                                minWidth: 0, // 🔥 ESSENCIAL pro ellipsis funcionar
                                            }}
                                        >
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    fontSize: 12,
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                {fornecedorNomeCurto}
                                            </Typography>
                                        </Box>

                                        {/* Checkbox */}
                                        <Checkbox
                                            size="small"
                                            checked={preCotacaoSelecionada === 1}
                                            onChange={() => handleChangePreCotacaoSelected(idPreCotacao)}
                                            disabled={!(parseInt(status_ordem) <= 10)}
                                            sx={{ p: 0.3 }}
                                        />
                                    </Box>
                                </Tooltip>
                            ),
                            columns: [
                                {
                                    accessorFn: row => {
                                        const cotacao = row.fornecedor_insumo[i];
                                        if (cotacao) {
                                            return {
                                                valor_unitario: cotacao.valor_unitario,
                                                valor_desconto: cotacao.valor_desconto,
                                                descricao_cotacao: cotacao.descricao,
                                                observacoes: cotacao.observacoes,
                                                link: cotacao.link,
                                                cotacao: cotacao,
                                            };
                                        } else {
                                            return {
                                                valor_unitario: 0.0,
                                                valor_desconto: 0.0,
                                                descricao_cotacao: "",
                                                observacoes: "",
                                                link: "",
                                                descricao_insumo: "",
                                                cotacao: null,
                                            };
                                        }
                                    },
                                    id: `valor_unitario${i + 1}`,
                                    header: 'Valor Unitário',
                                    size: 130,
                                    maxHeight: 130,
                                    Cell: ({ renderedCellValue }) => {
                                        if (renderedCellValue.valor_unitario > 0.0) {
                                            return (
                                                <Tooltip
                                                    title={
                                                        <Box sx={{ bgcolor: 'background.paper', color: 'text.primary', p: 1, minWidth: '200px', maxWidth: '400px', border: 1, borderColor: 'divider' }}>
                                                            <Box sx={{ fontWeight: 'bold' }}>Descrição da Cotação:</Box> {renderedCellValue.descricao_cotacao}
                                                            <Box sx={{ fontWeight: 'bold', mt: 1 }}>Observações do Insumo:</Box> {renderedCellValue.observacoes}

                                                            <Box sx={{ mt: 1 }}>
                                                                <Box sx={{ fontWeight: 'bold' }}>Valor Inicial:</Box> {currencyFormatter.format(renderedCellValue.valor_unitario)}
                                                                <Box sx={{ fontWeight: 'bold' }}>Desconto:</Box> {currencyFormatter.format(renderedCellValue.valor_desconto)}
                                                            </Box>

                                                            <Box sx={{ mt: 1, fontWeight: 'bold' }}>Valor Final:</Box> {currencyFormatter.format(renderedCellValue.valor_unitario - renderedCellValue.valor_desconto)}

                                                            {renderedCellValue.link && (
                                                                <Box sx={{ mt: 1 }}>
                                                                    <a href={renderedCellValue.link} target="_blank" rel="noopener noreferrer" style={{ color: 'blue' }}>Acessar</a>
                                                                </Box>
                                                            )}
                                                        </Box>
                                                    }
                                                    placement="top"
                                                    arrow
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                bgcolor: 'background.paper',
                                                                color: 'text.primary',
                                                                border: 1,
                                                                borderColor: 'divider',
                                                                '& .MuiTooltip-arrow': {
                                                                    color: 'background.paper',
                                                                }
                                                            }
                                                        }
                                                    }}
                                                >


                                                    <Box
                                                        sx={{
                                                            maxWidth: '130px',
                                                            wordWrap: 'break-word',
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            color: 'text.primary',
                                                            gap: '4px',
                                                        }}
                                                    >

                                                        {renderedCellValue.valor_unitario > 0.0
                                                            ? currencyFormatter.format(
                                                                renderedCellValue.valor_unitario - renderedCellValue.valor_desconto
                                                            )
                                                            : '---'}

                                                        {/* 🔹 Ícone aparece apenas se houver desconto */}
                                                        {renderedCellValue.valor_desconto > 0 && (
                                                            <DiscountIcon
                                                                style={{
                                                                    color: '#4caf50', // verde indicando desconto
                                                                    fontSize: '16px',
                                                                }}
                                                            />
                                                        )}
                                                    </Box>
                                                </Tooltip>
                                            );

                                        } else {
                                            return (
                                                <Box sx={{ maxWidth: '130px', wordWrap: 'break-word', display: 'inline-block', color: 'text.primary' }}>
                                                    {"---"}
                                                </Box>

                                            );
                                        }
                                    },
                                },
                                {
                                    accessorFn: row => {
                                        const cotacao = row.fornecedor_insumo[i];
                                        const item = row.fornecedor_insumo2[i];
                                        if (cotacao)
                                            return {
                                                valor_parcial: (cotacao.valor_unitario - cotacao.valor_desconto) * row.quantidade,
                                                selecionado: item.selecionado,
                                                id_item_ordem_compra: item.id_item_ordem_compra,
                                            }
                                        else
                                            return {
                                                valor_parcial: 0.0,
                                                selecionado: 0,
                                                id_cotacao: cotacao?.id_cotacao,
                                            }
                                    },
                                    Footer: () => (
                                        <Stack sx={{ color: 'text.primary', bgcolor: 'background.paper', fontWeight: 'initial', fontSize: 16 }}>
                                            <Tooltip
                                                title={
                                                    <Box sx={{ bgcolor: 'background.paper', border: 1, borderColor: 'divider', color: 'text.primary', padding: 2 }}>
                                                        Valor Itens: <Box>{currencyFormatter.format(valor_total_por_fornecedor)}</Box>
                                                        <br></br>
                                                        Desconto: <Box>{currencyFormatter.format(valor_desconto_geral_por_fornecedor)}</Box>
                                                        <br></br>
                                                        <Box sx={{ fontSize: 14, color: 'text.primary' }}><strong>Valor com Desconto:</strong> {currencyFormatter.format(valor_total_por_fornecedor - valor_desconto_geral_por_fornecedor)}</Box>
                                                        <br />
                                                        Valor Frete: <Box>{currencyFormatter.format(valor_frete_por_fornecedor)}</Box>
                                                    </Box>
                                                }
                                                placement="top"
                                                arrow
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            bgcolor: 'background.paper',
                                                            color: 'text.primary',
                                                            border: 1,
                                                            borderColor: 'divider',
                                                            '& .MuiTooltip-arrow': {
                                                                color: 'background.paper',
                                                            }
                                                        }
                                                    }
                                                }}
                                            >
                                                Valor Total:
                                                <Box>
                                                    {currencyFormatter.format(valor_total_por_fornecedor + valor_frete_por_fornecedor - valor_desconto_geral_por_fornecedor)}
                                                </Box>
                                            </Tooltip>
                                            <br></br><br></br>
                                            <Tooltip
                                                title={
                                                    <Box sx={{ bgcolor: 'background.paper', border: 1, borderColor: 'divider', color: 'text.primary', padding: 2 }}>
                                                        Valor Itens Selecionados: <Box>{currencyFormatter.format(valor_total_selecionado_por_fornecedor)}</Box>
                                                        <br></br>
                                                        Valor Frete: <Box>{currencyFormatter.format(valor_frete__se_1_item_selecionadopor_fornecedor)}</Box>
                                                    </Box>
                                                }
                                                placement="top"
                                                arrow
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            bgcolor: 'background.paper',
                                                            color: 'text.primary',
                                                            border: 1,
                                                            borderColor: 'divider',
                                                            '& .MuiTooltip-arrow': {
                                                                color: 'background.paper',
                                                            }
                                                        }
                                                    }
                                                }}
                                            >
                                                Valor Total de Itens Selecionados:
                                                <Box>
                                                    {currencyFormatter.format(valor_total_selecionado_por_fornecedor + valor_frete__se_1_item_selecionadopor_fornecedor)}
                                                </Box>
                                            </Tooltip>
                                        </Stack>
                                    ),

                                    id: `valor_total${i + 1}`,
                                    header: 'Valor Total',
                                    size: 160,
                                    maxWidth: 160,
                                    Cell: ({ renderedCellValue }) => (
                                        <Grid item xs={12} container direction="row" alignItems="center" justifyContent={"center"}>
                                            <Grid item xs={6} container direction="row" alignItems="center" justifyContent={"flex-end"}>
                                                <Box sx={{ wordWrap: 'break-word', display: 'inline-block', color: 'text.primary' }}>
                                                    {renderedCellValue.valor_parcial > 0.0 ? currencyFormatter.format(renderedCellValue.valor_parcial) : "---"}
                                                </Box>

                                            </Grid>
                                            <Grid item xs={1} container direction="row" alignItems="center" justifyContent={"flex-start"}>
                                                {renderedCellValue.valor_parcial > 0.0 &&
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={renderedCellValue.selecionado === 1}
                                                                onChange={(e) => {
                                                                    handleChangeSelected(renderedCellValue.id_item_ordem_compra);
                                                                    e.target.checked = renderedCellValue.selecionado === 0;
                                                                }}
                                                                disabled={!(parseInt(status_ordem) <= 10)} // Usando status_ordem como no original
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                            />
                                                        }
                                                        label=""
                                                    />
                                                }
                                            </Grid>
                                        </Grid>
                                    ),
                                },
                            ],
                        });
                    }

                    setObjetosAnalise(objetosAnaliseLocal);
                    setColumnsAnalise(columns);
                    setLoading(false);
                });
            });
        } catch (_err) {
            console.log("Erro ao recálcular informações: " + _err);
        }
    }




    const [atualizador, setAtualizador] = useState(0);

    useEffect(() => {

        setIdUsuarioLogado(parseInt(Cookies.get("id_usuario")));

        listarInformacoes();


    }, [atualizador]);






    async function finalizarParaAutorizar() {
        setIsLoading(true); // Ativar o indicador de carregamento

        // 🔎 Verifica se existe ao menos uma pré-cotação
        if (!ordemCompra.pre_cotacoes || ordemCompra.pre_cotacoes.length === 0) {
            setIsLoading(false);
            alert("É necessário cadastrar no mínimo uma pré-cotação antes de finalizar para autorização.");
            return;
        }


        // 🔎 Validação das pré-cotações
        for (let i = 0; i < ordemCompra.pre_cotacoes.length; i++) {
            const preCotacao = ordemCompra.pre_cotacoes[i];

            // 1) Verificar se há pelo menos 1 método de pagamento
            if (!preCotacao.metodos_pagamento || preCotacao.metodos_pagamento.length === 0) {
                setIsLoading(false);
                alert(`A pré-cotação ID ${preCotacao.id_pre_cotacao} não possui nenhum método de pagamento selecionado. Revise antes de finalizar.`);
                return;
            }

            // 2) Se algum método for PIX(1) ou TED(2), exigir conta bancária
            const exigeContaBancaria = preCotacao.metodos_pagamento.some(
                metodo => metodo.id_metodo_pagamento === 1 || metodo.id_metodo_pagamento === 2
            );
            if (exigeContaBancaria && (!preCotacao.conta_bancaria || preCotacao.conta_bancaria === "")) {
                setIsLoading(false);
                alert(`A pré-cotação ID ${preCotacao.id_pre_cotacao} exige conta bancária para o método de pagamento (PIX/TED), mas nenhuma foi selecionada. Revise antes de finalizar.`);
                return;
            }

            // 3) Número de parcelas > 0
            if (!preCotacao.numero_parcelas || parseInt(preCotacao.numero_parcelas) <= 0) {
                setIsLoading(false);
                alert(`A pré-cotação ID ${preCotacao.id_pre_cotacao} possui número de parcelas inválido. Revise antes de finalizar.`);
                return;
            }
        }

        const shouldProceed = window.confirm(
            "Ao finalizar a edição, ela será posta em Ánalise e só poderá ser corrigida após análise de um dos Solicitantes da Ordem de Compra. Deseja prosseguir?"
        );

        if (shouldProceed) {
            setOpen(true);

            try {
                console.log("cadastrar chamado");

                const headers = {
                    'Authorization': 'Bearer ' + Cookies.get("token")
                };

                const response = await api.put(
                    '/v1/protected/ordensdecompras/ordemdecompra/finalizarparaautorizar/' + idOrdemCompra,
                    {}, // body vazio
                    { headers: headers }
                );

                const cadastro_salvo = response.data;

                if (cadastro_salvo) {
                    alert("Ordem foi Fechada para Ánalise dos Solicitantes");
                    window.location.reload();
                } else {
                    alert("Erro de Conexão, tente novamente mais tarde");
                }
            } catch (_err) {
                console.log("erro ao cadastrar: " + _err);
                alert("Erro de Conexão, tente novamente mais tarde");
            }
        }
    }



    async function handleChangePreCotacaoSelected(id_pre_cotacao) {

        setOpenAtualizando(true);

        try {

            console.log("cadastrar chamado");
            const cadastro = {

            }

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.put("/v1/protected/ordensdecompras/ordemdecompra/atualizarprecotacaoselecionadasemdesmarcar/" + id_pre_cotacao + "/" + idOrdemCompra,
                { headers: headers });

            const cadastro_salvo = response.data;

            if (cadastro_salvo) {
                recalcular();

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }

            setOpenAtualizando(false);

        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");
            setOpenAtualizando(false);

        }

    }


    async function handleChangeSelected(id_item_ordem_compra) {
        setOpenAtualizando(true);

        try {

            console.log("cadastrar chamado");
            const cadastro = {

            }

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.put("/v1/protected/ordensdecompras/ordemdecompra/atualizaritemordemcompraselecionado/" + id_item_ordem_compra + "/" + idOrdemCompra,
                { headers: headers });

            const cadastro_salvo = response.data;

            if (cadastro_salvo) {


                recalcular();


            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }

            setOpenAtualizando(false);

        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");
            setOpenAtualizando(false);

        }

    }






    const handleChange = (event, newValue) => {
        setValue(newValue);

    }

    const handleChangeDocs = (event, newValue) => {
        setValueDocs(newValue);

    }



    const handleOpenAutorizar = (event, newValue) => {
        console.log("open autorizar chamado!");
        setOpenAutorizar(true);
    }





    const handleChangeIndex = (index) => {
        setValue(index);
    };



    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }



    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick = (param, event) => {
        event.stopPropagation();
    };






    function verificarSolicitante() {
        const id_usuario = parseInt(Cookies.get("id_usuario"));

        if (!id_usuario) {
            // Se o ID do usuário não estiver definido no cookie, retorne falso
            return false;
        }

        // Verifique cada solicitante selecionado
        for (let i = 0; i < solicitantesSelecionados.length; i++) {
            const solicitante = solicitantesSelecionados[i];
            if (parseInt(solicitante.id_usuario) === id_usuario) {
                // Se o ID do solicitante for igual ao ID do usuário atual, retorne verdadeiro
                return true;
            }
        }

        // Se nenhum dos IDs dos solicitantes for igual ao ID do usuário, retorne falso
        return false;
    }






    function returnDescricaoFornecedor(fornecedor) {

        var identificacao = fornecedor.tipo_fornecedor === 0 ? "CPF " : "CNPJ;"

        var valor = fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj;

        var nome = fornecedor.tipo_fornecedor === 0 ? (fornecedor.nome + " " + fornecedor.sobrenome) :
            (fornecedor.nome_fantasia);

        var endereco = fornecedor.logradouro + ", nº " + fornecedor.numero + ", " + fornecedor.bairro + ", " + fornecedor.cidade + " " + fornecedor.estado + " CEP: " + fornecedor.cep;


        var texto = "ID: " + fornecedor.id_fornecedor +
            "\n " + nome +
            + "\n" + identificacao + " " + valor + "\n Endereço: " + endereco;
        return texto;
    }

    const responseMessage = (response) => {
        //console.log(response);
    };
    const errorMessage = (error) => {
        // console.log(error);
    };


    const [openAutorizar, setOpenAutorizar] = useState(false)
    const [codigoValidacao, setCodigoValidacao] = useState("");


    const [cotacaoEscolhida, setCotacaoEscolhida] = useState(-1);
    const [openDialogMotivo, setOpenDialogMotivo] = useState(false);





    function handleCloseDialogMotivo() {
        setCotacaoEscolhida(-1);
        setOpenDialogMotivo(false);
    }

    function handleClickMotivoEscolha() {

        ordemCompra.pre_cotacoes?.forEach((pre, idxPre) => {
            pre.itens_pre_cotacao?.forEach((item, idxItem) => {
                console.log(
                    `Pré-cotação ${idxPre} - Item ${idxItem} | Selecionado: ${item.selecionado} | Dados:`,
                    item
                );
            });
        });

        const temSelecionado = ordemCompra.pre_cotacoes?.some(pre =>
            pre.itens_pre_cotacao?.some(item => item.selecionado === 1)
        );

        if (!temSelecionado) {
            alert("Nenhum item selecionado, você deve escolher os itens para Encerrar a Ánalise!");
            return;
        }


        //  setCotacaoEscolhida(escolha);
        setOpenDialogMotivo(true);
    }



    function returnStatus() {
        switch (ordemCompra.status) {
            case 0:
                return 'Editando';
                break;
            case 1:
                return 'Aguardando Escolha de Cotação';
                break;
            case 2:
                return 'Aguardando Autorização';
                break;
            case 3:
                return 'Autorizado, em Faturamento';
                break;
            case 4:
                return 'Recebimento Concluído';
                break;
            case 9:
                return 'Cancelada';
                break;
            case -2:
                return 'Suprida via Estoque';
                break;
            default:
                return 'Status não identificado';
        }
    }

    async function autorizar() {

        try {

            setOpen(true);
            const id_usuario = Cookies.get('id_usuario');

            console.log("id usuario: " + id_usuario);



            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const id_user = parseInt(Cookies.get("id_usuario"), 10);

            let pular = false;
            var valido = false;

            if (id_user === 1 || id_user === 11 || id_user === 62 || id_user === 55) {
                pular = true;
                valido = true;
            }

            if (!pular) {
                const response = await api.post('/v1/protected/validarparaautorizar/key/' + id_usuario + "/" + parseInt(codigoValidacao),
                    { headers: headers });

                valido = response.data.valid;
            }

            if (valido) {


                const response = await api.put('/v1/protected/ordensdecompras/ordemdecompra/autorizar/' + idOrdemCompra + "/" + Cookies.get("id_usuario"),
                    { headers: headers });

                const cadastro_salvo = response.data;

                if (cadastro_salvo) {
                    alert("Autorização Concluída, aguarde autorizações dos demais Solicitantes ou Diretores!");
                    window.location.reload();
                } else {
                    alert("112 Erro de Conexão, tente novamente mais tarde");
                }



            } else {
                alert("Código Inválido!");
            }
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("113 Erro de Conexão, tente novamente mais tarde");

        }

    }

    function returnDescricaoSolicitante(ordem_compra_solicitante) {
        var texto = ordem_compra_solicitante.solicitante.nome_amigavel;
        return texto;
    }


    function returnDescricaoUsuario(usuario) {
        var texto = usuario.nome_amigavel;
        return texto;
    }


    function returnDescricaoOrdem(ordem) {
        var texto = "ID: " + ordem.id_ordem_servico + "\n Solicitação: " + ordem.solicitacao.solicitacao;
        return texto;
    }


    async function escolher() {

        //percorrer o array de pre_cotacoes e ver se tem pelo menos um item de algumaa
        //pre cotacao selecionado
        ordemCompra.pre_cotacoes?.forEach((pre, idxPre) => {
            pre.itens_pre_cotacao?.forEach((item, idxItem) => {
                console.log(
                    `Pré-cotação ${idxPre} - Item ${idxItem} | Selecionado: ${item.selecionado} | Dados:`,
                    item
                );
            });
        });

        const temSelecionado = ordemCompra.pre_cotacoes?.some(pre =>
            pre.itens_pre_cotacao?.some(item => item.selecionado === 1)
        );

        if (!temSelecionado) {
            alert("Nenhum item selecionado, você deve escolher os itens para Encerrar a Ánalise!");
            return;
        }
        const shouldProceed = window.confirm("Ao finalizar a Ánalise Orçamentária, a Ordem de Compra será posta em status de autorização, após a autorização será enviada para Faturamento, prosseguir?");

        if (shouldProceed) {

            setBotaoEscolherFaturamentoCliquado(true);

            try {

                console.log("cadastrar chamado");
                const cadastro = {
                    dado1: motivoEscolha,
                }

                const headers = {
                    'Authorization': 'Bearer ' + Cookies.get("token")
                }

                const response = await api.put('/v1/protected/ordensdecompras/ordemdecompra/finalizaranaliseorcamentaria/' + idOrdemCompra + "/" + Cookies.get("id_usuario"), cadastro,
                    { headers: headers });

                const cadastro_salvo = response.data;

                if (cadastro_salvo) {
                    alert("Ordem aguardando todas as autorizações necessárias!")
                    window.location.reload();
                } else {
                    alert("Erro de Conexão, tente novamente mais tarde");
                }


            } catch (_err) {
                console.log("erro ao cadastrar: " + _err);
                alert("Erro de Conexão, tente novamente mais tarde");
                setBotaoEscolherFaturamentoCliquado(false);

            }
        }

    }



    function novaPreCotacao() {
        /*
                var id_usuario_logado = parseInt(Cookies.get("id_usuario"));
        
                if (ordemCompra.usuario.id_usuario === id_usuario_logado)
                    window.location.href = "/gestao/administracao/ordensdecompras/editar/" + idOrdemCompra + "/cadastrarcotacao";
                else {
                    alert("Somente o usuário criador da Ordem pode fazer esta operação!");
                    return;
                }*/


        setOpenDialogNovaCotacao(true);
    }


    const handleClickEdicaoPreCotacao = (cellValues) => {

        window.location.href = "/gestao/administracao/ordensdecompras/editar/" + idOrdemCompra + "/editarcotacao/" + cellValues.row.id_pre_cotacao;

    };

    const handleClickEdicaoCompra = (cellValues) => {

        window.location.href = "/gestao/administracao/ordensdecompras/editar/" + idOrdemCompra + "/editarcompra/" + cellValues.row.id_pre_cotacao;

    };


    const gerarLancamento = (id) => {
        window.open(
            "/gestao/financas/lancamento/cadastrar?idprecotacao=" + id,
            "_blank"
        );
    };


    const gerarEntradaEstoque = (id) => {
        window.open(
            "/gestao/operacional/almoxarifado/entradaestoque/cadastrarentradaestoque?id-pre-cotacao=" + id,
            "_blank"
        );
    };



    async function handleClickEdicaoRemoverPreCotacao(cellValues) {



        const shouldProceed = window.confirm("Remover a Pré-Cotação?");

        if (shouldProceed) {

            try {

                console.log("cadastrar chamado");
                const cadastro = {
                    dado1: motivoEscolha,
                }

                const headers = {
                    'Authorization': 'Bearer ' + Cookies.get("token")
                }

                const response = await api.delete("/v1/protected/ordensdecompras/ordemdecompra/removerprecotacao/" + idOrdemCompra + "/" + cellValues.row.id_pre_cotacao,
                    { headers: headers });

                const cadastro_salvo = response.data;

                if (cadastro_salvo) {
                    alert("Pré-Cotação Removida!");
                    window.location.reload();
                } else {
                    alert("Erro de Conexão, tente novamente");
                }


            } catch (_err) {
                console.log("erro ao cadastrar: " + _err);
                alert("Erro de Conexão, tente novamente!");
            }
        }


    }



    async function baixarAnexoPreCotacao(preCotacao) {
        try {
            const token = Cookies.get('token');
            const headers = {
                'Authorization': 'Bearer ' + token
            }

            const response = await api.post("/v1/protected/ordensdecompras/precotacao/baixaranexo", { caminho: encodeURIComponent(preCotacao.caminho_arquivo_fornecedor) }, {
                headers: headers,
                responseType: 'arraybuffer',  // Indica que a resposta é um array de bytes
            });


            const extensao = preCotacao.caminho_arquivo_fornecedor.split('.').pop().toLowerCase(); // Obtém a última parte do caminho após o último ponto e converte para minúsculas


            // Determina o tipo de mídia com base na extensão do arquivo
            let mediaType = 'application/octet-stream'; // Define um tipo padrão
            switch (extensao) {
                case 'pdf':
                    mediaType = 'application/pdf';
                    break;
                case 'doc':
                    mediaType = 'application/msword';
                    break;
                case 'docx':
                    mediaType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                    break;
                case 'xls':
                    mediaType = 'application/vnd.ms-excel';
                    break;
                case 'xlsx':
                    mediaType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    break;
                // Adicione outros tipos de arquivo conforme necessário
            }

            const blob = new Blob([response.data], { type: mediaType });

            // Cria uma URL do blob
            const blobUrl = URL.createObjectURL(blob);

            // Obtém o nome do arquivo a partir do caminho
            const nomeArquivo = preCotacao.caminho_arquivo_fornecedor.split('/').pop(); // Obtém a última parte do caminho após a última barra

            // Cria um link <a> temporário
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = nomeArquivo; // Define o nome do arquivo a ser baixado
            link.click(); // Simula um clique no link para iniciar o download
        } catch (error) {
            // Trate os erros conforme necessário
            console.log("Erro ao baixar o arquivo: " + error);
        }
    }


    const columnsPreCotacaoDataGrid = [
        {
            field: 'acoes',
            headerName: 'Ações',
            headerClassName: 'cabecalho_marrom_claro',
            sortable: false,
            width: 100,
            renderCell: (cellValues) => {
                return (
                    <div>
                        <IconButton onClick={() => handleClickEdicaoPreCotacao(cellValues)}>
                            <EditIcon />
                        </IconButton>

                        <IconButton onClick={() => handleClickEdicaoRemoverPreCotacao(cellValues)}>
                            <Delete />
                        </IconButton>


                    </div>
                )
            },
        },


        {
            headerName: 'ID',
            field: 'id_pre_cotacao',
            id: 1,
            width: 50,
            headerClassName: 'cabecalho_azul',
        },

        {
            id: 2,
            headerName: 'Arquivo',
            width: '50',
            sortable: false,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                return (
                    <div >
                        {
                            cellValues.row.caminho_arquivo_fornecedor ? (
                                <div
                                    onClick={() => {
                                        const link = cellValues.row.caminho_arquivo_fornecedor.replaceAll(
                                            "/home/wwgrup/ordensdecompra/",
                                            "https://gruporosinetos.com/ocmidias/"
                                        );
                                        window.open(link, "_blank", "noopener,noreferrer");
                                    }}
                                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '30px', height: '30px' }}
                                >
                                    {/* Verifica a extensão do arquivo e exibe a miniatura ou o ícone correspondente */}
                                    {cellValues.row.caminho_arquivo_fornecedor.toLowerCase().endsWith('.pdf') ? (
                                        <img alt={'miniatura_pdf'} style={{ textAlign: 'center' }} src={miniatura_pdf} />
                                    ) : (
                                        <img alt={'office'} style={{ textAlign: 'center' }} src={office} />
                                    )}

                                </div>
                            ) : (
                                <div >

                                </div>
                            )
                        }
                    </div>
                )

            },
        },

        {
            field: 'fornecedor',
            id: 3,
            headerName: 'Fornecedor',
            minWidth: 300,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const fornecedor = cellValues.row.fornecedor;

                const nomeExibido = fornecedor.tipo_fornecedor === 0
                    ? `${fornecedor.nome} ${fornecedor.sobrenome}`
                    : fornecedor.nome_fantasia;

                const infoCompleta = `${fornecedor.id_fornecedor}\n` +
                    `${nomeExibido}\n` +
                    `CPF/CNPJ: ${fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj}`;

                return (
                    <Tooltip
                        title={
                            <div style={{ whiteSpace: 'pre-line', backgroundColor: isDark ? '#333' : 'white', color: isDark ? 'white' : 'black', padding: '8px' }}>
                                <strong style={{ color: isDark ? '#90caf9' : 'blue' }}>{nomeExibido}</strong><br />
                                ID: {fornecedor.id_fornecedor}<br />
                                CPF/CNPJ: {fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj}
                            </div>
                        }
                        arrow
                        placement="top-start"
                    >
                        <Typography fontWeight="bold">
                            {nomeExibido}
                        </Typography>
                    </Tooltip>
                );
            },
        },


        {
            field: 'itens_pre_cotacao',
            id: 4,
            headerName: 'Itens',
            minWidth: '180',
            headerClassName: 'cabecalho_azul',
            type: 'number',

            renderCell: (cellValues) => {
                var itens = cellValues.row.itens_pre_cotacao


                return (

                    <Tooltip
                        title={
                            <div

                                style={{
                                    backgroundColor: isDark ? '#1E1E1E' : 'white',
                                    height: '70vh',
                                    width: '70vw',
                                    overflow: 'auto',
                                    border: isDark ? '2px solid #555' : '2px solid black',
                                }}                                >



                                <DataGrid
                                    rows={itens.filter((item) => item.cotacao.valor_unitario > 0)}
                                    getRowId={(row) => row.id_item_ordem_compra}
                                    columns={columnsItensFornecedorDataGrid}
                                    disableColumnResize={false}
                                    rowHeight={30}
                                    hideFooter
                                    autoHeight={false}
                                />

                            </div>
                        }
                        placement="left"
                        arrow

                    >

                        <Box
                            sx={{
                                border: isDark ? '1px solid #90caf9' : '1px solid #1976d2',        // Borda azul
                                backgroundColor: isDark ? '#1A237E' : '#e3f2fd',         // Azul claro (legível)
                                color: isDark ? '#90caf9' : '#0d47a1',                   // Azul escuro para bom contraste
                                padding: '1px 1px',
                                borderRadius: '4px',
                                display: 'inline-block',
                                fontWeight: 'bold'
                            }}
                        >
                            <Typography sx={{ color: isDark ? '#90caf9' : '#0d47a1', fontWeight: 'bold' }}>
                                Itens
                            </Typography>
                        </Box>
                    </Tooltip>

                )

            },
        },

        {
            field: 'valor_frete',
            id: 5,
            headerName: 'Valor do Frete',
            minWidth: '120',
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                var valor = cellValues.row.valor_frete

                return (
                    <div >
                        {
                            currencyFormatter.format(valor)
                        }
                    </div>
                )

            },
        },




    ];


    const [anchorElListaItens, setAnchorElListaItens] = React.useState(null);

    const handleClickListaItens = (event) => {
        setAnchorElListaItens(event.currentTarget);
    };

    const handleCloseListaItens = () => {
        setAnchorElListaItens(null);
    };

    function handleClickEditarListaRequerimentos(event) {

        if (ordemCompra.ordem_servico?.itens_pre_requerimento) {
            //ordem de compra com ordem de servico e deve ser editado pelo criador da OS
            var id_usuario_logado = parseInt(Cookies.get("id_usuario"));
            setOpenListaOs(false);
            handleClickListaItens(event);

            //const url = "/gestao/administracao/ordensdeservicos/editar/" + ordemCompra.ordem_servico.id_ordem_servico;
            //window.location.href = url;


        } else {
            //ordem de compra criada sem OS anexada

            var id_usuario_logado = parseInt(Cookies.get("id_usuario"));

            if (ordemCompra.usuario.id_usuario === id_usuario_logado) {

                const url = "/gestao/administracao/ordensdecompras/" + ordemCompra.id_ordem_compra + "/editarlistarequerimentos";
                window.location.href = url;
            } else {
                alert("Somente o usuário criador da Ordem pode fazer esta operação!");
                return;
            }

        }


    }


    async function handleOrcamento() {
        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            };

            const response = await api.get(
                `/v1/protected/ordensdecompras/ordemdecompra/gerarpedidoorcamento/${idOrdemCompra}/0`,
                { headers }
            );

            // Abre a URL retornada em uma nova guia
            if (response.data) {
                window.open(response.data.replaceAll(
                    "/home/wwgrup/ordensdecompra/",
                    "https://gruporosinetos.com/ocmidias/"
                ), '_blank');
            } else {
                console.warn("Nenhuma URL retornada pelo servidor.");
            }

        } catch (err) {
            console.error("Erro ao pedir orçamento:", err);
        }
    }



    function handleFinalizarSemCompras() {


    }

    function handleClickGerenciarLancamento(id_lancamento) {
        const url = `/gestao/financas/lancamento/gerenciar/${id_lancamento}`;
        window.open(url, '_blank');
    }


    function handleClickGerenciarEntradaEstoque(id) {
        const url = `/gestao/operacional/almoxarifado/entradaestoque/gerenciarentradaestoque/${id}`;
        window.open(url, '_blank');
    }

    const [openListaOs, setOpenListaOs] = useState(false);
    const [anchorElListaOs, setAnchorElListaOs] = useState(null);

    const handleClickListaOs = (event) => {
        setAnchorElListaOs(event.currentTarget);
        setOpenListaOs((prev) => !prev);
    };

    const handleClickAwayListaOs = () => {
        setOpenListaOs(false);
    };





    const columnsComprasDataGrid = [
        {
            field: "acoes",
            headerName: "Ações",
            headerClassName: "cabecalho_marrom_claro",
            sortable: false,
            width: 150,
            renderCell: (params) => {
                const { id_pre_cotacao, id_lancamento, id_entrada_estoque } = params.row;

                const podeGerar = !id_lancamento || id_lancamento <= 0;
                const podeGerarEntrada = !id_entrada_estoque || id_entrada_estoque <= 0;

                return (
                    <div style={{ display: "flex", gap: 4 }}>
                        {/* Botão editar */}
                        <Tooltip title="Editar Compra">
                            <IconButton onClick={() => handleClickEdicaoCompra(params)}>
                                <EditIcon />
                            </IconButton>
                        </Tooltip>

                        {/* Botão gerar lançamento */}
                        {podeGerar && (
                            <Tooltip title="Gerar Despesa a Pagar">
                                <IconButton
                                    color="success"
                                    size="small"
                                    onClick={() => gerarLancamento(id_pre_cotacao)}
                                >
                                    <AttachMoneyIcon />
                                </IconButton>
                            </Tooltip>
                        )}

                        {/* Botão gerar lançamento */}
                        {podeGerarEntrada && (
                            <Tooltip title="Gerar Entrada de Estoque">
                                <IconButton
                                    color="success"
                                    size="small"
                                    onClick={() => gerarEntradaEstoque(id_pre_cotacao)}
                                >
                                    <AddBoxIcon />
                                </IconButton>
                            </Tooltip>
                        )}
                    </div>
                );
            },
        },


        {
            headerName: 'ID',
            field: 'id_pre_cotacao',
            id: 2,
            width: 50,
            headerClassName: 'cabecalho_azul',
        },

        {
            id: 3,
            field: 'arquivo', // Adicionei  
            headerName: 'Arquivo',
            width: 50,
            sortable: false,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                return (
                    <div style={{ color: isDark ? 'white' : 'black' }}>
                        {
                            cellValues.row.caminho_arquivo ? (
                                <div
                                    onClick={() => {
                                        baixarArquivo(cellValues.row.caminho_arquivo);
                                    }}
                                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '30px', height: '30px' }}
                                >
                                    {/* Verifica a extensão do arquivo e exibe a miniatura ou o ícone correspondente */}
                                    {cellValues.row.caminho_arquivo.toLowerCase().endsWith('.pdf') &&
                                        <img alt={'miniatura_pdf'} style={{ textAlign: 'center' }} src={miniatura_pdf} />
                                    }

                                </div>
                            ) : (
                                <div >

                                </div>
                            )
                        }
                    </div >
                )
            }
        },
        {
            field: 'lancamento',
            id: 4,
            headerName: 'Lançamento',
            minWidth: 80,
            headerClassName: 'cabecalho_azul',
            type: 'number',
            renderCell: (cellValues) => {
                return (
                    <div>
                        <IconButton onClick={() => handleClickGerenciarLancamento(cellValues.row.id_lancamento)}>
                            <MonetizationOnIcon />
                        </IconButton>
                    </div>
                );
            },
        },
        {
            field: 'entrada_estoque',
            id: 5,
            headerName: 'Estoque',
            minWidth: 80,
            headerClassName: 'cabecalho_azul',
            type: 'number',
            renderCell: (cellValues) => {
                return (
                    <div>
                        <IconButton onClick={() => handleClickGerenciarEntradaEstoque(cellValues.row.id_entrada_estoque)}>
                            <InventoryIcon />
                        </IconButton>
                    </div>
                );
            },
        },

        {
            id: 6,
            field: 'informacoes', // Adicionei um campo 
            headerName: 'Informações',
            minWidth: 50,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {

                const envios = cellValues.row.registros_envio;



                return (
                    <Tooltip
                        title={
                            <div style={{ backgroundColor: isDark ? '#1E1E1E' : 'white', padding: 20, color: isDark ? 'white' : 'black', size: 16, minHeight: '50px', minWidth: '400px', border: isDark ? '2px solid #555' : '2px solid black' }}>

                                <Typography variant="body2" style={{ display: 'flex', alignItems: 'center', paddingTop: 20 }}>
                                    <strong>Código da Compra:</strong> {cellValues.row.codigo_compra}
                                    {cellValues.row.link_compra &&
                                        <a
                                            href={cellValues.row.link_compra}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <Typography variant="body2" style={{ paddingLeft: 10 }}>Acessar Compra</Typography>
                                        </a>
                                    }
                                </Typography>
                                <br></br>
                                <Typography variant="body2" style={{ display: 'flex', alignItems: 'center', paddingTop: 20 }}>
                                    <strong>Código do Rastreio:</strong> {cellValues.row.codigo_rastreio}
                                    {cellValues.row.link_rastreio &&
                                        <a
                                            href={cellValues.row.link_rastreio}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <Typography variant="body2" style={{ paddingLeft: 10 }}>Acessar Rastreio</Typography>
                                        </a>
                                    }
                                </Typography>
                                <br></br>
                                <Typography variant="body2">
                                    <strong>Observações:</strong> {cellValues.row.observacao_compra}
                                </Typography>
                                <br></br>

                                {envios.map((envio, index) => (
                                    <Card key={index} style={{ marginBottom: '10px', borderRadius: '8px', border: '1px solid gray' }}>
                                        <CardContent>
                                            <Typography variant="body2">
                                                <strong>Vendedor:</strong> {envio.vendedor.nome_contato}
                                            </Typography>
                                            <Typography variant="body2">
                                                <strong>Plataforma de Envio:</strong> {envio.plataforma_envio === 0 ? 'WhatsApp' : 'Email'}
                                            </Typography>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Typography variant="body2" style={{ display: 'flex', alignItems: 'center' }}>
                                                    <strong>Enviado:</strong> {envio.enviado === 1 ? <Email /> : <EmailOutlined />}
                                                </Typography>
                                                {envio.enviado === 1 && (
                                                    <Typography variant="body2" style={{ marginLeft: '8px' }}>
                                                        {moment(envio.data_hora_envio).format('DD/MM/YYYY HH:mm')}
                                                    </Typography>
                                                )}
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Typography variant="body2" style={{ display: 'flex', alignItems: 'center' }}>
                                                    <strong>Visualizado:</strong> {envio.vizualizado === 1 ? <Visibility /> : <VisibilityOff />}
                                                </Typography>
                                                {envio.vizualizado === 1 && (
                                                    <Typography variant="body2" style={{ marginLeft: '8px' }}>
                                                        {moment(envio.data_hora_vizualizado).format('DD/MM/YYYY HH:mm')}
                                                    </Typography>
                                                )}
                                            </div>
                                        </CardContent>
                                    </Card>
                                ))}
                            </div>
                        }
                        placement="right"
                        arrow
                        style={{ backgroundColor: isDark ? '#333' : 'white' }}
                        sx={{ backgroundColor: isDark ? '#333' : 'white' }}
                    >
                        <Box
                            sx={{
                                border: '1px solid #1976d2',
                                backgroundColor: isDark ? '#0d47a1' : '#e3f2fd',
                                color: isDark ? 'white' : '#0d47a1',
                                padding: '1px 1px',
                                borderRadius: '4px',
                                display: 'inline-block',
                                fontWeight: 'bold'
                            }}
                        >
                            <Typography sx={{ color: isDark ? 'white' : '#0d47a1', fontWeight: 'bold' }}>
                                Info
                            </Typography>
                        </Box>
                    </Tooltip>

                );
            },

        },


        {
            field: 'fornecedor',
            id: 7,
            headerName: 'Fornecedor',
            minWidth: 350,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const fornecedor = cellValues.row.fornecedor;

                const nomeExibido = fornecedor.tipo_fornecedor === 0
                    ? `${fornecedor.nome} ${fornecedor.sobrenome}`
                    : fornecedor.nome_fantasia;

                const infoCompleta = `${fornecedor.id_fornecedor}\n` +
                    `${nomeExibido}\n` +
                    `CPF/CNPJ: ${fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj}`;

                return (
                    <Tooltip
                        title={
                            <div style={{ whiteSpace: 'pre-line' }}>
                                <strong style={{ fontSize: '1.1rem', color: 'white' }}>{nomeExibido}</strong><br />
                                ID: {fornecedor.id_fornecedor}<br />
                                CPF/CNPJ: {fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj}
                            </div>
                        }
                        arrow
                        placement="top-start"
                    >
                        <Typography fontWeight="bold" noWrap>
                            {nomeExibido}
                        </Typography>
                    </Tooltip>
                );
            },
        },



        {
            field: 'itens_pre_cotacao',
            id: 8,
            headerName: 'Itens',
            minWidth: '180',
            headerClassName: 'cabecalho_azul',
            type: 'number',

            renderCell: (cellValues) => {
                var itens = cellValues.row.itens_pre_cotacao


                return (
                    <div style={{
                        backgroundColor: isDark ? '#1E1E1E' : 'white',
                        height: '60vh',             // 50% da height da viewport
                        width: '60vw',              // 50% da largura da viewport
                        overflow: 'auto',           // adiciona scroll se necessário
                        border: isDark ? '2px solid #555' : '2px solid black',
                        color: isDark ? 'white' : 'black',
                    }} >
                        <Tooltip
                            title={
                                <div
                                    style={{
                                        backgroundColor: isDark ? '#1E1E1E' : 'white',
                                        height: '70vh',             // 50% da altura da viewport
                                        width: '70vw',              // 50% da largura da viewport
                                        overflow: 'auto',           // adiciona scroll se necessário
                                        border: isDark ? '2px solid #444' : '2px solid black',
                                        color: isDark ? 'white' : 'black'
                                    }}

                                >

                                    <Grid
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                    >

                                        <DataGrid
                                            rows={itens.filter((item) => item.cotacao.valor_unitario > 0)}
                                            getRowId={(row) => row.id_item_ordem_compra}
                                            columns={columnsItensFornecedorDataGrid}
                                            disableColumnResize={false}
                                            rowHeight={30}
                                            hideFooter
                                            autoHeight={false}
                                        />
                                    </Grid>
                                </div>
                            }
                            placement="left"
                            arrow

                        >

                            <Box
                                sx={{
                                    border: '1px solid #1976d2',        // Borda azul
                                    backgroundColor: '#e3f2fd',         // Azul claro (legível)
                                    color: '#0d47a1',                   // Azul escuro para bom contraste
                                    padding: '1px 1px',
                                    borderRadius: '4px',
                                    display: 'inline-block',
                                    fontWeight: 'bold'
                                }}
                            >
                                <Typography sx={{ color: '#0d47a1', fontWeight: 'bold' }}>
                                    Itens Escolhidos
                                </Typography>
                            </Box>
                        </Tooltip>
                    </div>
                )

            },
        },


        {
            field: 'valor_frete',
            id: 9,
            headerName: 'Valor do Frete',
            minWidth: '120',
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                var valor = cellValues.row.valor_frete

                return (
                    <div >
                        {
                            currencyFormatter.format(valor)
                        }
                    </div>
                )

            },
        },



        {
            field: 'valor_total',
            id: 10,
            headerName: 'Valor dos Itens',
            minWidth: '120',
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                var valor = cellValues.row.valor_total

                return (
                    <div >
                        {
                            currencyFormatter.format(valor)
                        }
                    </div>
                )

            },
        },


        {
            field: 'valor_final',
            id: 11,
            headerName: 'Valor Total Final',
            minWidth: '120',
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                var valor1 = cellValues.row.valor_frete
                var valor2 = cellValues.row.valor_total

                return (
                    <div >
                        {
                            currencyFormatter.format(valor1 + valor2)
                        }
                    </div>
                )

            },
        },






    ];
    function returnDescricaoEndereco(objeto) {
        try {
            if (!objeto) throw new Error("Objeto de endereço inválido");

            const logradouro = objeto.logradouro || '';
            const numero = objeto.numero || '';
            const bairro = objeto.bairro || '';
            const cidade = objeto.cidade || '';
            const estado = objeto.estado || '';
            const cep = objeto.cep || '';

            return `${logradouro}, ${numero}, bairro ${bairro}, ${cidade} UF: ${estado} CEP: ${cep}`;
        } catch (error) {
            console.error("Erro em returnDescricaoEndereco:", error);
            return "Endereço indisponível";
        }
    }

    function returnDescricaoColaborador(colaborador) {
        try {
            if (!colaborador) throw new Error("Colaborador inválido");

            const endereco = returnDescricaoEndereco(colaborador);

            const idColaborador = colaborador.id_colaborador != null ? colaborador.id_colaborador : "N/A";
            const cpf = colaborador.cpf || "N/A";
            const nome = colaborador.nome || "";
            const sobrenome = colaborador.sobrenome || "";

            return `Colaborador_ID: ${idColaborador}\nCPF: ${cpf}\nNome: ${nome} ${sobrenome}\n${endereco}`;
        } catch (error) {
            console.error("Erro em returnDescricaoColaborador:", error);
            return "Colaborador inválido";
        }
    }

    const handleClickVizualizarProcedimento = (id) => {
        //   window.open(`/gestao/administracao/ordensdecompra/vizualizarprocedimentoexecucao/${id}/ordemservico/${ordemServico.id_ordem_servico}`, '_blank');
    };


    const handleClickAtualizarProcedimento = (procedimento) => {

        window.location.href = "/gestao/administracao/ordensdecompras/" + ordemCompra.id_ordem_compra + "/atualizarprocedimentoexecucao/" + procedimento.id_procedimento_execucao;

    };



    const [openCancelar, setOpenCancelar] = useState(false);
    const [motivoCancelamento, setMotivoCancelamento] = useState("");



    function handleOpenCancelar() {

        setOpenCancelar(true);
        setMotivoCancelamento("");
    };


    function handleCloseCancelar() {

        setOpenCancelar(false);
    };




    async function cancelarOrdemCompra() {
        try {
            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            };

            const cadastro = {
                id_usuario: Cookies.get("id_usuario"),
                motivo: motivoCancelamento,
            }

            const response = await api.put(
                `/v1/protected/ordensdecompras/cancelar/` + idOrdemCompra,
                cadastro,
                { headers }
            );

            if (response.data) {
                alert("Cancelamento Efetuado!");
                listarInformacoes();
                setOpenCancelar(false);
            } else {
                alert("Erro ao cancelar, consulte o administrador!");
            }

        } catch (err) {
            console.error("Erro ao atualizar arquivos:", err);
            alert("Erro de conexão, tente novamente mais tarde.");
        }
    }





    const [openFinalizar, setOpenFinalizar] = useState(false);
    const [motivoFinalizar, setMotivoFinalizar] = useState("");



    function handleOpenFinalizar() {

        setOpenFinalizar(true);
        setMotivoFinalizar("");
    };


    function handleCloseFinalizar() {

        setOpenFinalizar(false);
    };




    async function finalizarOrdemCompra() {
        try {
            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            };

            const cadastro = {
                id_usuario: Cookies.get("id_usuario"),
                motivo: motivoFinalizar,
            }

            const response = await api.put(
                `/v1/protected/ordensdecompras/finalizar/` + idOrdemCompra,
                cadastro,
                { headers }
            );

            if (response.data) {
                alert("Ordem de Compra Finalizada!");
                listarInformacoes();
                handleCloseFinalizar();
            } else {
                alert("Erro ao finalizar, consulte o administrador!");
            }

        } catch (err) {
            alert("Erro de conexão, tente novamente mais tarde.");
        }
    }




    function returnDescricaoUnidade(unidade) {



        var nome = unidade.nome_fantasia;

        var endereco = unidade.logradouro + ", nº " + unidade.numero + ", " + unidade.bairro + ", " + unidade.cidade + " " + unidade.estado + " CEP: " + unidade.cep;


        var texto = nome + " | " + unidade.cnpj;
        return texto;
    }




    function returnDescricaoInsumo(insumo) {

        // Se não houver correspondência, retorna a descrição principal do insumo
        return insumo.descricao;
    }


    function returnDescricaoInstalacao(instalacao) {
        var texto = "SIGMA: " + instalacao.identificador_integrador + "\n Instalacao_ID: " + instalacao.id_instalacao + "\n CPF/CNPJ: " + (instalacao.tipo_instalacao === 0 ? instalacao.cpf : instalacao.cnpj) +
            "\n Nome/Nome Fantasia: " + (instalacao.tipo_instalacao === 0 ? (instalacao.nome + " " + instalacao.sobrenome) : instalacao.nome_fantasia);

        return texto;
    }




    function returnDescricaoProjeto(projeto) {
        try {
            if (!projeto) return "Projeto não informado";

            const texto =
                (projeto.id_projeto || "") + " - " + (projeto.nome_projeto || "") + "\n" +
                (projeto.descricao_projeto || "") + "\n" +
                (projeto.instalacao ? returnDescricaoInstalacao(projeto.instalacao) : "");

            return texto;
        } catch (e) {
            console.error("Erro ao montar descrição do projeto:", e);
            return "Erro ao obter dados do projeto";
        }
    }

    function returnDescricaoProposta(proposta) {
        console.log("proposta: " + proposta.id_proposta);
        var texto = proposta.id_proposta + " - " + proposta.descricao_proposta;
        return texto;

    }



    function returnDescricaoProjetoPeD(projeto) {
        var texto = projeto.id_projeto + " - " + projeto.nome_projeto + " | " + projeto.descricao_projeto;
        return texto;
    }

    function returnDescricaoInsumoSimplificada(insumo) {


        var texto =


            "Descrição: " + insumo.descricao;
        return texto;
    }

    const columnsItensDataGrid = [

        {
            headerName: 'Insumo',
            field: 'insumo',
            id: 2,
            width: 300,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const insumo = cellValues.row.insumo;



                let textoComQuebraDeLinha = "Descrição Principal: " + insumo.descricao + "\n\n";

                if (insumo.variacoes && insumo.variacoes.length > 0) {
                    textoComQuebraDeLinha += insumo.variacoes

                        .map((variacao, index) => (
                            `Fornecedor: ${variacao.nome_amigavel_fornecedor} Variação: ${variacao.descricao}${index !== insumo.variacoes.length - 1 ? '\n' : ''}`
                        )).join('');
                } else {
                    return (
                        <span>{returnDescricaoInsumo(insumo)}</span>
                    );
                }

                return (
                    <Tooltip
                        title={
                            <div style={{ backgroundColor: isDark ? '#1E1E1E' : 'white', color: isDark ? 'white' : 'black', size: 16, minHeight: '50px', minWidth: '400px', border: isDark ? '2px solid #555' : '2px solid black' }}>
                                <span>
                                    {textoComQuebraDeLinha.split('\n').map((line, index) => (
                                        <React.Fragment key={index}>
                                            {line}
                                            <br />
                                        </React.Fragment>
                                    ))}
                                </span>
                            </div>
                        }
                        placement="top"
                        arrow
                        style={{ backgroundColor: isDark ? '#1E1E1E' : 'white' }}
                        sx={{ backgroundColor: isDark ? '#1E1E1E' : 'white' }}
                    >
                        <span>{returnDescricaoInsumo(insumo)}</span>
                    </Tooltip>
                );
            },
        },



        {
            headerName: 'Qtd Pedida',
            field: 'quantidade',
            id: 3,
            width: 130,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'Qtd Reservada',
            field: 'quantidade_reservada',
            id: 4,
            width: 130,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'Qtd a Comprar',
            field: 'quantidade_a_comprar',
            id: 5,
            width: 130,
            headerClassName: 'cabecalho_azul',
        },

        {
            headerName: 'Observações',
            field: 'observacoes',
            id: 6,
            width: 300, // 🔹 Metade do tamanho original (600 → 300)
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => (
                <div
                    style={{
                        whiteSpace: 'pre-wrap', // 🔹 Permite quebra automática
                        overflowWrap: 'break-word',
                        wordBreak: 'break-word',
                    }}
                >
                    {params.value}
                </div>
            ),
        },

    ];


    const columnsItensFornecedorDataGrid = [

        {
            headerName: 'Insumo',
            field: 'insumo',
            id: 2,
            width: 200,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const insumo = cellValues.row.insumo;



                let textoComQuebraDeLinha = "Descrição Principal: " + insumo.descricao + "\n\n";

                if (insumo.variacoes && insumo.variacoes.length > 0) {
                    textoComQuebraDeLinha += insumo.variacoes

                        .map((variacao, index) => (
                            `Fornecedor: ${variacao.nome_amigavel_fornecedor} Variação: ${variacao.descricao}${index !== insumo.variacoes.length - 1 ? '\n' : ''}`
                        )).join('');
                } else {
                    return (
                        <span>{returnDescricaoInsumo(insumo)}</span>
                    );
                }

                return (
                    <Tooltip
                        title={
                            <div style={{ backgroundColor: isDark ? '#1E1E1E' : 'white', color: isDark ? 'white' : 'black', size: 16, minHeight: '50px', minWidth: '400px', border: isDark ? '2px solid #555' : '2px solid black' }}>
                                <span>
                                    {textoComQuebraDeLinha.split('\n').map((line, index) => (
                                        <React.Fragment key={index}>
                                            {line}
                                            <br />
                                        </React.Fragment>
                                    ))}
                                </span>
                            </div>
                        }
                        placement="left"
                        arrow
                        style={{ backgroundColor: isDark ? '#1E1E1E' : 'white' }}
                        sx={{ backgroundColor: isDark ? '#1E1E1E' : 'white' }}
                    >
                        <span>{returnDescricaoInsumo(insumo)}</span>
                    </Tooltip>
                );
            },
        },

        {
            field: 'cotacao.unidade',
            id: 3,
            headerName: 'Unidade',
            minWidth: '120',
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                var valor = cellValues.row.cotacao.unidade

                return (
                    <div >
                        {
                            valor
                        }
                    </div>
                )

            },
        },


        {
            headerName: 'Quantidade',
            field: 'quantidade',
            id: 4,
            width: 100,
            headerClassName: 'cabecalho_azul',


        },

        {
            field: 'cotacao.valor_unitario',
            id: 5,
            headerName: 'Valor Unitário',
            minWidth: '120',
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                var valor = cellValues.row.cotacao.valor_unitario - cellValues.row.cotacao.valor_desconto;

                return (
                    <div >
                        {
                            currencyFormatter.format(valor)
                        }
                    </div>
                )

            },
        },

        {
            field: 'total',
            id: 6,
            headerName: 'Valor Total',
            minWidth: '120',
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                var valor = (cellValues.row.cotacao.valor_unitario - cellValues.row.cotacao.valor_desconto) * cellValues.row.quantidade;

                return (
                    <div >
                        {
                            currencyFormatter.format(valor)
                        }
                    </div>
                )

            },
        },


        {
            headerName: 'Observações',
            field: 'observacoes',
            id: 7,
            width: 250,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                var valor = cellValues.row.cotacao.observacoes

                return (
                    <div >
                        {
                            valor
                        }
                    </div>
                )

            },
        },

    ];




    const [isOpen, setIsOpen] = useState(false);
    const [cotacaoNovaTarefa, setCotacaoNovaTarefa] = useState(null);

    const openModal = (cotacao) => {
        if (cotacao) {
            setCotacaoNovaTarefa(cotacao);
            setIsOpen(true);
        }
    };

    const closeModal = () => {
        setIsOpen(false);
        setCotacaoNovaTarefa(null);
    };


    const [isOpenResposta, setIsOpenResposta] = useState(false);
    const [tarefaResponder, setTarefaResponder] = useState(null);

    const openModalResposta = (tarefa) => {
        if (tarefa) {
            console.log("id da tarefa a responder: " + tarefa.id_tarefa);
            setTarefaResponder(tarefa);
            setIsOpenResposta(true);
        }
    };

    const closeModalResposta = () => {
        setIsOpenResposta(false);
        setTarefaResponder(null);
    };



    const CustomDialog = ({ cotacao }) => {
        const [mensagem, setMensagem] = useState('');



        const handleMensagemChange = (event) => {
            setMensagem(event.target.value);
        };

        async function cadastrarTarefa() {


            console.log("id do cotacao a criar nova tarefa: " + cotacao.id_cotacao);


            try {

                console.log("cadastrar chamado");
                const cadastro_tarefa = {

                    mensagem: mensagem,
                    usuario_criador: { id_usuario: Cookies.get("id_usuario") },
                    id_ordem_compra: ordemCompra.id_ordem_compra,
                    id_cotacao: cotacao.id_cotacao,
                    usuario_destinado: { id_usuario: ordemCompra.usuario.id_usuario },


                }



                const headers = {
                    'Authorization': 'Bearer ' + Cookies.get("token")
                }

                const response = await api.post('/v1/protected/almoxarifado/cotacao/' + cotacao.id_cotacao + "/cadastrartarefa", cadastro_tarefa,
                    { headers: headers });

                const cadastro_salvo = response.data;
                if (cadastro_salvo) {
                    alert("Tarefa Cadastrada!");
                    closeModal();

                } else {
                    alert("Erro de Conexão, tente novamente mais tarde");
                }


            } catch (_err) {
                console.log("erro ao cadastrar: " + _err);
                alert("Erro de Conexão, tente novamente mais tarde");

            }
        }


        return (

            <Dialog open={isOpen} onClose={closeModal} PaperProps={{ style: { maxWidth: '600px', minWidth: '300px' } }}>
                <DialogTitle>Nova Tarefa</DialogTitle>
                <DialogContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12} style={{ paddingTop: 20 }}>
                            <TextField
                                label="Mensagem"
                                variant="outlined"
                                fullWidth
                                value={mensagem}
                                onChange={handleMensagemChange}
                                multiline
                                minRows={3}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button onClick={cadastrarTarefa} variant="contained" color="primary">
                                ok
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        );

    };



    const CustomDialogResposta = ({ tarefa }) => {
        const [resposta, setResposta] = useState('');



        const handleRespostaChange = (event) => {
            setResposta(event.target.value);
        };

        async function responderTarefa() {



            try {

                console.log("cadastrar chamado");
                const cadastro_tarefa = {

                    resposta: resposta,
                }



                const headers = {
                    'Authorization': 'Bearer ' + Cookies.get("token")
                }

                const response = await api.post('/v1/protected/almoxarifado/cotacao/respondertarefa/' + tarefa.id_tarefa, cadastro_tarefa,
                    { headers: headers });

                const cadastro_salvo = response.data;
                if (cadastro_salvo) {
                    alert("Tarefa Finalizada!");
                    closeModalResposta();

                } else {
                    alert("Erro de Conexão, tente novamente mais tarde");
                }


            } catch (_err) {
                console.log("erro ao cadastrar: " + _err);
                alert("Erro de Conexão, tente novamente mais tarde");

            }



        }



        return (

            <Dialog open={isOpenResposta} onClose={closeModalResposta} PaperProps={{ style: { maxWidth: '600px', minWidth: '300px' } }}>
                <DialogTitle>Finalizar Tarefa</DialogTitle>
                <DialogContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12} style={{ paddingTop: 20 }}>
                            <TextField
                                label="Questão"
                                variant="outlined"
                                fullWidth
                                disabled
                                value={tarefa.mensagem}
                                multiline
                                minRows={1}
                            />
                        </Grid>
                        <Grid item xs={12} style={{ paddingTop: 20 }}>
                            <TextField
                                label="Resposta"
                                variant="outlined"
                                fullWidth
                                value={resposta}
                                onChange={handleRespostaChange}
                                multiline
                                minRows={3}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button onClick={responderTarefa} variant="contained" color="primary">
                                Finalizar
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        );
    };

    // Função para filtrar preCotacoes
    const filtrarPreCotacoes = (preCotacoes) => {
        return preCotacoes.filter(preCotacao =>
            preCotacao.itens_pre_cotacao.some(item => item.selecionado === 1)
        );
    };


    const [anchorElPopover5, setAnchorElPopover5] = React.useState(null);
    const openPopover5 = Boolean(anchorElPopover5);
    const handleClickPopover5 = (event) => {
        setAnchorElPopover5(anchorElPopover5 ? null : event.currentTarget); // toggle
    };
    const handleClosePopover5 = () => setAnchorElPopover5(null);


    return (
        <ThemeProviderV4 theme={themeV4}>
            <ThemeProviderV5 theme={themeV5}>
                <CssBaselineV4 />
                <CssBaselineV5 />
                <div style={{ width: '100%', margin: 0, padding: 0, backgroundColor: isDark ? '#121212' : '#fff', color: isDark ? '#fff' : '#000', minHeight: '100vh' }}>

                    {telaCheia && <div
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            backgroundColor: isDark ? '#121212' : 'white',
                            zIndex: 9999,
                            overflow: 'auto',
                            padding: 1,
                        }}
                    >
                        <Grid
                            container
                            direction="row"
                            item xs={12}
                            alignItems="center"
                            justifyContent="center"
                            style={{

                                backgroundColor: isDark ? '#121212' : 'white',
                                margin: 0,
                                padding: 0,
                            }}
                        >
                            <AnaliseOrcamentaria
                                ordemCompra={ordemCompra}
                                columnsItensDataGrid={columnsItensDataGrid}
                                isSolicitante={isSolicitante}
                                isSupervisor={isSupervisor}
                                handleClickMotivoEscolha={handleClickMotivoEscolha}
                                autorizou={autorizou}
                                handleOpenAutorizar={handleOpenAutorizar}
                                telaCheia={telaCheia}
                                handleToggleTelaCheia={handleToggleTelaCheia}
                                objetosAnalise={objetosAnalise}
                                columnsAnalise={columnsAnalise}
                                infoOrdem={infoOrdem}
                                currencyFormatter={currencyFormatter}
                                valorTotalGlobal={valorTotalGlobal}
                                isDark={isDark}
                                valorFreteGlobal={valorFreteGlobal}
                            />
                        </Grid>
                    </div>}

                    <NavegadorGestao
                        Gestao={true}
                        OrdensCompras={true}
                        corFundo={isDark ? '#1C1C1C' : 'white'} travado={true} corTexto={isDark ? 'white' : 'black'}
                        style={{ width: '100%', margin: 0, padding: 0 }}

                    />

                    <div style={{ paddingTop: 5, width: '100%', margin: 0, backgroundColor: isDark ? '#121212' : 'white' }} >
                        {loading
                            ?
                            <div></div>

                            :

                            <div style={{ width: '100%', margin: 0, padding: 0 }}>

                                <Grid
                                    item xs={12}
                                    container
                                    direction="row"
                                    alignItems="center"
                                    justifyContent={"center"}
                                    style={{ width: '100%', margin: 0, padding: 0 }}
                                >
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="flex-start"
                                        align="flex-start"
                                        item xs={10}
                                        style={{ width: '100%', margin: 0, padding: 0 }}
                                    >


                                        <a href="/gestao/administracao/ordensdecompras/listar" style={{ fontSize: 14, color: isDark ? 'white' : 'black', marginRight: '5px' }}>{"< Ordens de Compras"}</a>

                                        <a
                                            href={"/gestao/administracao/ordensdecompras/editar/" + ordemCompra.id_ordem_compra}
                                            style={{ fontSize: 14, color: isDark ? 'white' : 'black', marginRight: '5px' }}
                                        >
                                            {" | Ordem de Compra Nº " + ordemCompra.id_ordem_compra}
                                            {ordemServicoSelecionada && ordemServicoSelecionada.projeto && (
                                                " - " + ordemServicoSelecionada.projeto.nome_projeto
                                            )}
                                            {
                                                " | Status: " + returnStatus()
                                            }
                                        </a>
                                    </Grid>



                                    <Grid
                                        item xs={12}
                                        container
                                        direction="row"
                                        alignItems="center"
                                        justifyContent={"center"}
                                        style={{ width: '100%', margin: 0, padding: 0 }}
                                    >


                                        <Box style={{ width: '100%', margin: 0, padding: 0 }}>
                                            <AppBar position="static"
                                                style={{ width: '100%', margin: 0, padding: 0 }}
                                            >
                                                <Tabs
                                                    value={value}
                                                    onChange={handleChange}
                                                    indicatorColor="secondary"
                                                    textColor="inherit"
                                                    variant="scrollable"
                                                    scrollButtons="auto"
                                                    aria-label="scrollable auto tabs example"
                                                    style={{ width: "100%", margin: 0, padding: 0 }}
                                                >
                                                    <Tab
                                                        label={isMobile ? "" : "Especificações"}
                                                        icon={isMobile ? <ListAltIcon /> : <ListAltIcon />}
                                                        iconPosition={isMobile ? "top" : "end"} // ícone em cima no mobile, depois do texto no desktop
                                                        style={{ backgroundColor: isDark ? "#1C1C1C" : "#1C1C1C" }}
                                                    />
                                                    <Tab
                                                        label={isMobile ? "" : "Cotações"}
                                                        icon={isMobile ? <AttachMoneyIcon /> : <AttachMoneyIcon />}
                                                        iconPosition={isMobile ? "top" : "end"}
                                                        style={{ backgroundColor: isDark ? "#1C1C1C" : "#1C1C1C" }}
                                                    />
                                                    <Tab
                                                        label={isMobile ? "" : "Análise Orçamentária"}
                                                        icon={isMobile ? <AssessmentIcon /> : <AssessmentIcon />}
                                                        iconPosition={isMobile ? "top" : "end"}
                                                        style={{ backgroundColor: isDark ? "#1C1C1C" : "#1C1C1C" }}
                                                    />
                                                    <Tab
                                                        label={isMobile ? "" : "Compras"}
                                                        icon={isMobile ? <ShoppingCartIcon /> : <ShoppingCartIcon />}
                                                        iconPosition={isMobile ? "top" : "end"}
                                                        style={{ backgroundColor: isDark ? "#1C1C1C" : "#1C1C1C" }}
                                                    />
                                                    <Tab
                                                        label={isMobile ? "" : "Procedimentos"}
                                                        icon={isMobile ? <DescriptionIcon /> : <DescriptionIcon />}
                                                        iconPosition={isMobile ? "top" : "end"}
                                                        style={{ backgroundColor: "#1C1C1C" }}
                                                    />
                                                </Tabs>
                                            </AppBar>

                                        </Box>
                                    </Grid>


                                    <Grid
                                        item xs={12}
                                        container
                                        direction="row"
                                        alignItems="center"
                                        style={{ width: '100%', margin: 0, padding: 0 }}
                                        justifyContent={"center"}
                                    >

                                        <SwipeableViews
                                            index={value}
                                            onChangeIndex={handleChangeIndex}
                                            style={{ width: '100%', margin: 0, padding: 0 }}
                                        >
                                            <Grid value={value} index={0}
                                                container
                                                direction="row"
                                                item xs={12}
                                                alignItems="center"
                                                justifyContent="center"
                                                style={{ width: '100%', padding: 10, alignItems: 'center', }}
                                            >

                                                <Grid
                                                    item xs={12}
                                                    container
                                                    direction="row"
                                                    alignItems="center"
                                                    justifyContent={"center"}
                                                    style={{ marginRight: 10, marginLeft: 10 }}
                                                >


                                                    <Box style={{ maxHeight: '40px', backgroundColor: isDark ? '#1C1C1C' : 'white', width: '100%', alignItems: 'center', }}>
                                                        <AppBar position="static" style={{ backgroundColor: isDark ? '#1C1C1C' : '#3f51b5' }}>

                                                            <Tabs
                                                                value={valueDocs}
                                                                onChange={handleChangeDocs}
                                                                indicatorColor="secondary"
                                                                textColor="inherit"
                                                                variant="scrollable"
                                                                scrollButtons="auto"
                                                                aria-label="scrollable auto tabs example"
                                                            >
                                                                <Tab
                                                                    label={isMobile ? "" : "Informações Iniciais"}
                                                                    icon={isMobile ? <InfoIcon /> : null}
                                                                    style={{ backgroundColor: isDark ? "#1C1C1C" : "#1C1C1C" }}
                                                                />
                                                                <Tab
                                                                    label={isMobile ? "" : "Imagens"}
                                                                    icon={isMobile ? <ImageIcon /> : null}
                                                                    style={{ backgroundColor: isDark ? "green" : "green" }}
                                                                />
                                                                <Tab
                                                                    label={isMobile ? "" : "Vídeos"}
                                                                    icon={isMobile ? <VideoLibraryIcon /> : null}
                                                                    style={{ backgroundColor: isDark ? "green" : "green" }}
                                                                />
                                                                <Tab
                                                                    label={isMobile ? "" : "Documentos"}
                                                                    icon={isMobile ? <DescriptionIcon /> : null}
                                                                    style={{ backgroundColor: isDark ? "green" : "green" }}
                                                                />
                                                            </Tabs>
                                                        </AppBar>

                                                    </Box>
                                                </Grid>

                                                <SwipeableViews
                                                    index={valueDocs}
                                                    onChangeIndex={handleChangeIndexDocs}
                                                    style={{ backgroundColor: isDark ? '#1E1E1E' : 'white', width: '100%', alignItems: 'center', }}
                                                >

                                                    <Grid
                                                        style={{ padding: 30 }}
                                                        container
                                                        direction="row"
                                                        item xs={12}
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        spacing={1}
                                                        value={valueDocs} index={0}

                                                    ><Grid
                                                        style={{ padding: 5 }}
                                                        container
                                                        direction="row"
                                                        item xs={12}
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        spacing={1}
                                                    >
                                                            {/* Tipo de Ordem de Compra */}
                                                            <Grid item xs={6}>
                                                                <FormControl fullWidth variant="outlined">
                                                                    <FormLabel component="legend" sx={{ fontWeight: 'bold', mb: 1 }}>
                                                                        Tipo de Ordem de Compra
                                                                    </FormLabel>
                                                                    <TextField
                                                                        value={
                                                                            ordemCompra.tipo_ordem === 0 ? "Ordem de Compra" :
                                                                                ordemCompra.tipo_ordem === 1 ? "Solicitação de Pagamento" :
                                                                                    "Não definido"
                                                                        }
                                                                        InputProps={{
                                                                            readOnly: true,
                                                                            style: { color: isDark ? 'white' : 'black' }
                                                                        }}
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-root': {
                                                                                backgroundColor: isDark ? '#333' : '#f5f5f5',
                                                                                '& fieldset': {
                                                                                    borderColor: isDark ? '#444' : '#e0e0e0',
                                                                                },
                                                                            },
                                                                            '& .MuiInputLabel-root': {
                                                                                color: isDark ? 'white' : 'inherit'
                                                                            }
                                                                        }}
                                                                    />
                                                                </FormControl>
                                                            </Grid>

                                                            {/* Tipo de Mercadoria - Condicional */}
                                                            {ordemCompra.tipo_ordem === 0 && (
                                                                <Grid item xs={6}>
                                                                    <FormControl fullWidth variant="outlined">
                                                                        <FormLabel component="legend" sx={{ fontWeight: 'bold', mb: 1 }}>
                                                                            Tipo de Mercadoria
                                                                        </FormLabel>
                                                                        <TextField
                                                                            value={
                                                                                ordemCompra.tipo_mercadoria === 0 ? "Entrada de Mercadoria Física/Digital" :
                                                                                    ordemCompra.tipo_mercadoria === 1 ? "Sem recebimento de mercadoria" :
                                                                                        "Não definido"
                                                                            }
                                                                            InputProps={{
                                                                                readOnly: true,
                                                                                style: { color: isDark ? 'white' : 'black' }
                                                                            }}
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    backgroundColor: isDark ? '#333' : '#f5f5f5',
                                                                                    '& fieldset': {
                                                                                        borderColor: isDark ? '#444' : '#e0e0e0',
                                                                                    },
                                                                                },
                                                                                '& .MuiInputLabel-root': {
                                                                                    color: isDark ? 'white' : 'inherit'
                                                                                }
                                                                            }}
                                                                        />
                                                                    </FormControl>
                                                                </Grid>
                                                            )}
                                                        </Grid>
                                                        <Grid
                                                            style={{ padding: 5 }}
                                                            container
                                                            direction="row"
                                                            item xs={10}
                                                            alignItems="center"
                                                            justifyContent="center"
                                                        >
                                                            <Grid item xs={6}>
                                                                <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center', gap: 1, color: isDark ? 'white' : 'inherit' }}>
                                                                    {(() => {
                                                                        let icon = null;
                                                                        let title = '';

                                                                        switch (ordemCompra.status) {
                                                                            case 0:
                                                                                icon = <EditNoteIcon sx={{ color: 'gray' }} />;
                                                                                title = 'Editando';
                                                                                break;
                                                                            case 1:
                                                                                icon = <HourglassTopIcon sx={{ color: 'orange' }} />;
                                                                                title = 'Aguardando Escolha de Cotação';
                                                                                break;
                                                                            case 2:
                                                                                icon = <TaskIcon sx={{ color: '#1976d2' }} />;
                                                                                title = 'Aguardando Autorização';
                                                                                break;
                                                                            case 3:
                                                                                icon = <AssignmentTurnedInIcon sx={{ color: 'green' }} />;
                                                                                title = 'Autorizado, em Faturamento';
                                                                                break;
                                                                            case 4:
                                                                                icon = <CheckCircleIcon sx={{ color: 'limegreen' }} />;
                                                                                title = 'Recebimento Concluído';
                                                                                break;
                                                                            case 9:
                                                                                icon = <CancelIcon sx={{ color: 'red' }} />;
                                                                                title = 'Cancelada';
                                                                                break;
                                                                            case -2:
                                                                                icon = <InventoryIcon sx={{ color: 'green' }} />;
                                                                                title = 'Suprida via Estoque';
                                                                                break;
                                                                            default:
                                                                                title = 'Status não identificado';
                                                                        }

                                                                        return (
                                                                            <>

                                                                                {icon}
                                                                                {"Status: " + title}
                                                                            </>
                                                                        );
                                                                    })()}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>

                                                        <Box
                                                            component="button"
                                                            onClick={handleOpenCancelar}
                                                            style={{
                                                                backgroundColor: isDark ? "#c62828" : "#f44336",
                                                                color: "#fff",
                                                                padding: "6px 16px",
                                                                border: "none",
                                                                borderRadius: "4px",
                                                                fontSize: "0.875rem",
                                                                fontWeight: 500,
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "8px",
                                                            }}
                                                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = isDark ? "#b71c1c" : "#d32f2f")}
                                                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = isDark ? "#c62828" : "#f44336")}
                                                        >
                                                            <CancelIcon />
                                                            Cancelar
                                                        </Box>

                                                        <Grid
                                                            style={{ paddingTop: 10 }}
                                                            container
                                                            direction="row"
                                                            item xs={12}
                                                            alignItems="center"
                                                            justifyContent="center"
                                                        >

                                                            <Grid item xs={12}>
                                                                <TextField
                                                                    variant="standard"
                                                                    name="descricao"
                                                                    label="Descrição"
                                                                    id="descricao"
                                                                    value={descricao}
                                                                    onChange={(e) => setDescricao(e.target.value)}
                                                                    fullWidth
                                                                    multiline
                                                                    minRows={2}
                                                                    InputLabelProps={{ style: { color: isDark ? 'white' : 'inherit' } }}
                                                                    inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                />
                                                            </Grid>

                                                        </Grid>

                                                        {ordemCompra.usuario &&
                                                            <Grid
                                                                container
                                                                direction="row"
                                                                justifyContent="center"
                                                                align="center"
                                                                item xs={12} sm={12} md={3} lg={3} xl={3}
                                                                style={{ margin: 5 }}
                                                            >
                                                                <Grid
                                                                    container
                                                                    direction="column"
                                                                    justifyContent="center"
                                                                    align="center"
                                                                    item xs={12}
                                                                >

                                                                    <Autocomplete
                                                                        id="select-ordem-usuario"
                                                                        options={[ordemCompra.usuario]}
                                                                        disableCloseOnSelect
                                                                        getOptionLabel={(usuario) => returnDescricaoUsuario(usuario).replace(/<br \/>/g, '\n')}
                                                                        value={ordemCompra.usuario}
                                                                        getOptionSelected={(option, value) => true}
                                                                        renderInput={(params) => (
                                                                            <TextField {...params} label=" Usuário Criador " multiline minRows={3}
                                                                                InputLabelProps={{ style: { color: isDark ? 'white' : 'inherit' } }}
                                                                                inputProps={{ ...params.inputProps, style: { ...params.inputProps.style, color: isDark ? 'white' : 'black' } }}
                                                                            />
                                                                        )}
                                                                        renderOption={(option) => (
                                                                            <div dangerouslySetInnerHTML={{ __html: returnDescricaoUsuario(option) }} style={{ color: isDark ? 'white' : 'black' }} />
                                                                        )}

                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        }




                                                        {ordemServicoSelecionada && (
                                                            <Grid
                                                                container
                                                                direction="row"
                                                                justifyContent="center"
                                                                align="center"
                                                                item xs={12} sm={12} md={3} lg={3} xl={3}
                                                                style={{ margin: 5 }}
                                                            >
                                                                <Grid
                                                                    container
                                                                    direction="column"
                                                                    justifyContent="center"
                                                                    align="center"
                                                                    item xs={12}
                                                                >

                                                                    <Autocomplete
                                                                        id="select-ordem-servico"
                                                                        options={[ordemServicoSelecionada]}
                                                                        disableCloseOnSelect
                                                                        getOptionLabel={(ordem) => returnDescricaoOrdem(ordem).replace(/<br \/>/g, '\n')}
                                                                        value={ordemServicoSelecionada}
                                                                        getOptionSelected={(option, value) => true}
                                                                        filterOptions={(options, { inputValue }) => {
                                                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                            return options.filter((ordem) => {
                                                                                const cotacaoText = returnDescricaoOrdem(ordem).toLowerCase();
                                                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                                            });
                                                                        }}
                                                                        renderInput={(params) => (
                                                                            <TextField {...params} label=" Ordem de Serviço " multiline minRows={3}
                                                                                InputLabelProps={{ style: { color: isDark ? 'white' : 'inherit' } }}
                                                                                inputProps={{ ...params.inputProps, style: { ...params.inputProps.style, color: isDark ? 'white' : 'black' } }}
                                                                            />
                                                                        )}
                                                                        renderOption={(option) => (
                                                                            <div dangerouslySetInnerHTML={{ __html: returnDescricaoOrdem(option) }} style={{ color: isDark ? 'white' : 'black' }} />
                                                                        )}

                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        )
                                                        }

                                                        {
                                                            ordemServicoSelecionada && ordemServicoSelecionada.projeto &&
                                                            <Grid
                                                                container
                                                                direction="column"
                                                                justifyContent="center"
                                                                align="center"
                                                                item xs={12} sm={12} md={3} lg={3} xl={3}
                                                            >
                                                                <TextField
                                                                    variant="standard"
                                                                    name="projeto"
                                                                    label="Projeto"
                                                                    id="projeto"
                                                                    value={returnDescricaoProjeto(ordemServicoSelecionada.projeto)}
                                                                    fullWidth
                                                                    multiline
                                                                    minRows={2}
                                                                    InputLabelProps={{ style: { color: isDark ? 'white' : 'inherit' } }}
                                                                    inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                />

                                                            </Grid>
                                                        }


                                                        {ordemServicoSelecionada && ordemServicoSelecionada.projeto && ordemServicoSelecionada.proposta &&
                                                            <Grid
                                                                container
                                                                direction="row"
                                                                justifyContent="center"
                                                                align="center"
                                                                item xs={12} sm={12} md={3} lg={3} xl={3}
                                                                style={{ marginTop: 20 }}
                                                            >
                                                                <Grid
                                                                    container
                                                                    direction="column"
                                                                    justifyContent="center"
                                                                    align="center"
                                                                    item xs={12}
                                                                >

                                                                    <TextField
                                                                        variant="standard"
                                                                        name="proposta"
                                                                        label="Proposta"
                                                                        id="proposta"
                                                                        value={returnDescricaoProposta(ordemServicoSelecionada.proposta)}
                                                                        fullWidth
                                                                        multiline
                                                                        minRows={1}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        }

                                                        {(ordemServicoSelecionada?.colaborador || ordemCompra?.colaborador)
                                                            && (
                                                                <Grid
                                                                    container
                                                                    direction="row"
                                                                    justifyContent="center"
                                                                    align="center"
                                                                    item xs={12} sm={12} md={3} lg={3} xl={3}
                                                                    style={{ marginTop: 20 }}
                                                                >
                                                                    <Grid
                                                                        container
                                                                        direction="column"
                                                                        justifyContent="center"
                                                                        align="center"
                                                                        item xs={12} >
                                                                        <Autocomplete
                                                                            id="select-colaborador"
                                                                            options={[]}
                                                                            disableCloseOnSelect
                                                                            getOptionLabel={(colaborador) => returnDescricaoColaborador(colaborador)}
                                                                            value={ordemServicoSelecionada?.colaborador ? ordemServicoSelecionada.colaborador : ordemCompra.colaborador}
                                                                            renderInput={(params) => (
                                                                                <TextField {...params} label=" Colaborador "
                                                                                    multiline
                                                                                    minRows={2}
                                                                                    InputLabelProps={{ style: { color: isDark ? 'white' : 'inherit' } }}
                                                                                    inputProps={{ ...params.inputProps, style: { ...params.inputProps.style, color: isDark ? 'white' : 'black' } }}
                                                                                />
                                                                            )}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            )
                                                        }


                                                        {solicitantesSelecionados && (

                                                            <Grid
                                                                container
                                                                direction="row"
                                                                justifyContent="center"
                                                                align="center"
                                                                item xs={12} sm={12} md={3} lg={3} xl={3}
                                                                style={{ margin: 5 }}
                                                            >
                                                                <Grid
                                                                    container
                                                                    direction="column"
                                                                    justifyContent="center"
                                                                    align="center"
                                                                    item xs={12}
                                                                >

                                                                    <Autocomplete
                                                                        id="select-procedimentos"
                                                                        options={[solicitantesSelecionados]}
                                                                        disableCloseOnSelect
                                                                        multiple
                                                                        getOptionLabel={(solicitante) => returnDescricaoSolicitante(solicitante).replace(/<br \/>/g, '\n')}
                                                                        value={solicitantesSelecionados}
                                                                        getOptionSelected={(option, value) => true}

                                                                        filterOptions={(options, { inputValue }) => {
                                                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                            return options.filter((solicitante) => {
                                                                                const cotacaoText = returnDescricaoSolicitante(solicitante).toLowerCase();
                                                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                                            });
                                                                        }}
                                                                        renderInput={(params) => (
                                                                            <TextField {...params} label=" Solicitantes " multiline minRows={3}
                                                                                InputLabelProps={{ style: { color: isDark ? 'white' : 'inherit' } }}
                                                                                inputProps={{ ...params.inputProps, style: { ...params.inputProps.style, color: isDark ? 'white' : 'black' } }}
                                                                            />
                                                                        )}
                                                                        renderOption={(option) => (
                                                                            <div dangerouslySetInnerHTML={{ __html: returnDescricaoSolicitante(option) }} style={{ color: isDark ? 'white' : 'black' }} />
                                                                        )}

                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        )
                                                        }


                                                        {projetoSelecionado && propostaSelecionada &&
                                                            (!ordemServicoSelecionada?.projeto) &&

                                                            <Grid
                                                                container
                                                                direction="row"
                                                                justifyContent="center"
                                                                align="center"
                                                                item xs={12}
                                                                style={{ marginTop: 5 }}
                                                                spacing={2}
                                                            >

                                                                <Grid
                                                                    container
                                                                    direction="row"
                                                                    justifyContent="flex-end"
                                                                    align="flex-end"
                                                                    item xs={6}
                                                                    style={{ marginTop: 5 }}
                                                                >
                                                                    <Grid
                                                                        container
                                                                        direction="column"
                                                                        justifyContent="center"
                                                                        align="center"
                                                                        item xs={8}
                                                                    >

                                                                        <TextField
                                                                            variant="standard"
                                                                            name="projeto"
                                                                            label="Projeto"
                                                                            id="projeto"
                                                                            value={returnDescricaoProjeto(projetoSelecionado)}
                                                                            fullWidth
                                                                            multiline
                                                                            minRows={1}
                                                                            InputLabelProps={{ style: { color: isDark ? 'white' : 'inherit' } }}
                                                                            inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                        />
                                                                    </Grid>
                                                                </Grid>

                                                                <Grid
                                                                    container
                                                                    direction="row"
                                                                    justifyContent="flex-start"
                                                                    align="flex-start"
                                                                    item xs={6}
                                                                    style={{ marginTop: 5 }}
                                                                >
                                                                    {
                                                                        projetoSelecionado && propostaSelecionada &&
                                                                        <Grid
                                                                            container
                                                                            direction="column"
                                                                            justifyContent="center"
                                                                            align="center"
                                                                            item xs={8}
                                                                        >
                                                                            <TextField
                                                                                variant="standard"
                                                                                name="proposta"
                                                                                label="Proposta"
                                                                                id="proposta"
                                                                                value={returnDescricaoProposta(propostaSelecionada)}
                                                                                fullWidth
                                                                                multiline
                                                                                minRows={2}
                                                                                InputLabelProps={{ style: { color: isDark ? 'white' : 'inherit' } }}
                                                                                inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                            />

                                                                        </Grid>
                                                                    }
                                                                </Grid>



                                                            </Grid>
                                                        }


                                                        <Grid
                                                            container
                                                            direction="column"
                                                            justifyContent="center"
                                                            alignItems="center"
                                                            item
                                                            xs={9} sm={9} md={9} lg={9} xl={9}
                                                            style={{
                                                                margin: 5,
                                                                border: isDark ? "1px solid #444" : "1px solid #ddd",        // borda suave
                                                                borderRadius: 8,                 // cantos arredondados
                                                                padding: 15,
                                                                boxShadow: isDark ? "0 2px 5px rgba(0,0,0,0.4)" : "0 2px 5px rgba(0,0,0,0.1)", // sombra leve
                                                                backgroundColor: isDark ? "#333" : "#fff",         // fundo branco
                                                                position: "relative",            // para posicionar o título
                                                            }}
                                                        >
                                                            {/* Título no canto superior esquerdo */}
                                                            <Typography
                                                                variant="h6"
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 10,
                                                                    left: 15,
                                                                    backgroundColor: isDark ? "#333" : "#fff",
                                                                    padding: "0 8px",
                                                                    color: isDark ? "#fff" : "#333",
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                Mídias
                                                            </Typography>

                                                            {todasImagens.length > 0 && (
                                                                <Swiper
                                                                    spaceBetween={10}
                                                                    slidesPerView={"auto"}
                                                                    navigation
                                                                    pagination={{ clickable: true }}
                                                                    modules={[Navigation, Pagination]}
                                                                    style={{
                                                                        width: "100%",
                                                                        maxWidth: 1200,
                                                                        paddingTop: 30, // deixa espaço para o título
                                                                    }}
                                                                >
                                                                    {todasImagens.map((img, index) => (
                                                                        <SwiperSlide key={index} style={{ textAlign: "center" }}>
                                                                            <img
                                                                                src={img.caminho}
                                                                                alt={img.descricao || `Imagem ${index + 1}`}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "auto",
                                                                                    borderRadius: 5,
                                                                                    cursor: "zoom-in",
                                                                                    border: "1px solid #eee", // borda suave na imagem
                                                                                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                                                }}
                                                                                onClick={() => setImagemZoom(img.caminho)}
                                                                            />
                                                                            {img.descricao && (
                                                                                <Typography
                                                                                    variant="body2"
                                                                                    style={{ marginTop: 8, color: "#555" }}
                                                                                >
                                                                                    {img.descricao}
                                                                                </Typography>
                                                                            )}
                                                                        </SwiperSlide>
                                                                    ))}
                                                                </Swiper>
                                                            )}
                                                        </Grid>


                                                        <Grid
                                                            container
                                                            direction="column"
                                                            justifyContent="center"
                                                            alignItems="center"
                                                            item
                                                            xs={2} sm={2} md={2} lg={2} xl={2}
                                                            style={{
                                                                margin: 5,
                                                                border: isDark ? "1px solid #444" : "1px solid #ddd",        // borda suave
                                                                borderRadius: 8,                 // cantos arredondados
                                                                padding: 15,
                                                                boxShadow: isDark ? "0 2px 5px rgba(0,0,0,0.4)" : "0 2px 5px rgba(0,0,0,0.1)", // sombra leve
                                                                backgroundColor: isDark ? "#333" : "#fff",         // fundo branco
                                                                position: "relative",            // para posicionar o título
                                                            }}
                                                        >
                                                            {/* Título no canto superior esquerdo */}
                                                            <Typography
                                                                variant="h6"
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 10,
                                                                    left: 15,
                                                                    backgroundColor: isDark ? "#333" : "#fff",
                                                                    padding: "0 8px",
                                                                    color: isDark ? "#fff" : "#333",
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                Documentos
                                                            </Typography>

                                                            {/* Lista de documentos */}
                                                            <Grid container spacing={2} style={{ marginTop: 5 }}>
                                                                {todosDocumentos.length > 0 ? (
                                                                    todosDocumentos.map((doc, index) => (
                                                                        <Grid
                                                                            item
                                                                            xs={12}
                                                                            key={index}
                                                                            container
                                                                            alignItems="center"
                                                                            style={{
                                                                                padding: "10px 0",
                                                                                borderBottom: index < todosDocumentos.length - 1 ? "1px solid #eee" : "none"
                                                                            }}
                                                                        >
                                                                            <div
                                                                                onClick={() => {
                                                                                    const link = doc.caminho.replace(
                                                                                        "/home/wwgrup/ordensdecompra/",
                                                                                        "https://gruporosinetos.com/ocmidias/"
                                                                                    );
                                                                                    window.open(link, "_blank", "noopener,noreferrer");
                                                                                }}
                                                                                style={{
                                                                                    cursor: "pointer",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center",
                                                                                    width: 50,
                                                                                    height: 50,
                                                                                    marginRight: 15
                                                                                }}
                                                                            >
                                                                                <InsertDriveFileIcon style={{ fontSize: 36, color: "#1976d2" }} />
                                                                            </div>

                                                                            <Typography variant="body1" style={{ color: isDark ? 'white' : '#555' }}>
                                                                                {doc.descricao || `Documento ${index + 1}`}
                                                                            </Typography>
                                                                        </Grid>
                                                                    ))
                                                                ) : (
                                                                    <Typography variant="body2" color="#999">
                                                                        Nenhum documento disponível
                                                                    </Typography>
                                                                )}
                                                            </Grid>
                                                        </Grid>



                                                    </Grid>


                                                    <Grid
                                                        value={value} index={1}
                                                        style={{ paddingTop: 30 }}
                                                        container
                                                        direction="row"
                                                        item xs={12}
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        spacing={2}
                                                    >




                                                        <Grid item xs={12} style={{ padding: 40 }}
                                                            container
                                                            alignItems="center"
                                                            justifyContent="center"
                                                        >




                                                            {/* BLOCO 1 */}
                                                            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                                                <Card>
                                                                    <CardContent style={{ position: "relative" }}>
                                                                        {(ordemCompra.caminho_imagem1 || imagemSelecionada1) && (
                                                                            <button
                                                                                onClick={() => handleRemoverImagem(1)}
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    top: 5,
                                                                                    right: 5,
                                                                                    background: "red",
                                                                                    color: "white",
                                                                                    border: "none",
                                                                                    borderRadius: "50%",
                                                                                    width: 28,
                                                                                    height: 28,
                                                                                    cursor: "pointer",
                                                                                    fontWeight: "bold"
                                                                                }}
                                                                            >
                                                                                X
                                                                            </button>
                                                                        )}

                                                                        {ordemCompra.caminho_imagem1 ? (
                                                                            <img
                                                                                src={ordemCompra.caminho_imagem1.replace(
                                                                                    "/home/wwgrup/ordensdecompra/",
                                                                                    "https://gruporosinetos.com/ocmidias/"
                                                                                )}
                                                                                alt="Imagem Selecionada 1"
                                                                                style={{ width: "100%", height: "auto", marginBottom: "10px" }}
                                                                            />
                                                                        ) : imagemSelecionada1 ? (
                                                                            <img
                                                                                src={URL.createObjectURL(imagemSelecionada1)}
                                                                                alt="Imagem Selecionada 1"
                                                                                style={{ width: "100%", height: "auto", marginBottom: "10px" }}
                                                                            />
                                                                        ) : (
                                                                            <div {...getRootProps1()} style={dropzoneStyles}>
                                                                                <input {...getInputProps1()} />
                                                                                <Typography align="center" variant="h5">
                                                                                    Arraste e solte uma imagem aqui ou clique para adicionar
                                                                                </Typography>
                                                                            </div>
                                                                        )}

                                                                        <Grid item xs={12} style={{ padding: 40 }}>
                                                                            <TextField
                                                                                variant="standard"
                                                                                label="Descrição"
                                                                                fullWidth
                                                                                multiline
                                                                                minRows={1}
                                                                                value={descricaoImagem1}
                                                                                onChange={(e) => setDescricaoImagem1(e.target.value)}
                                                                            />
                                                                        </Grid>
                                                                    </CardContent>
                                                                </Card>
                                                            </Grid>

                                                            {/* BLOCO 2 */}
                                                            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                                                <Card>
                                                                    <CardContent style={{ position: "relative" }}>
                                                                        {(ordemCompra.caminho_imagem2 || imagemSelecionada2) && (
                                                                            <button
                                                                                onClick={() => handleRemoverImagem(2)}
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    top: 5,
                                                                                    right: 5,
                                                                                    background: "red",
                                                                                    color: "white",
                                                                                    border: "none",
                                                                                    borderRadius: "50%",
                                                                                    width: 28,
                                                                                    height: 28,
                                                                                    cursor: "pointer",
                                                                                    fontWeight: "bold"
                                                                                }}
                                                                            >
                                                                                X
                                                                            </button>
                                                                        )}

                                                                        {ordemCompra.caminho_imagem2 ? (
                                                                            <img
                                                                                src={ordemCompra.caminho_imagem2.replace(
                                                                                    "/home/wwgrup/ordensdecompra/",
                                                                                    "https://gruporosinetos.com/ocmidias/"
                                                                                )}
                                                                                alt="Imagem Selecionada 2"
                                                                                style={{ width: "100%", height: "auto", marginBottom: "10px" }}
                                                                            />
                                                                        ) : imagemSelecionada2 ? (
                                                                            <img
                                                                                src={URL.createObjectURL(imagemSelecionada2)}
                                                                                alt="Imagem Selecionada 2"
                                                                                style={{ width: "100%", height: "auto", marginBottom: "10px" }}
                                                                            />
                                                                        ) : (
                                                                            <div {...getRootProps2()} style={dropzoneStyles}>
                                                                                <input {...getInputProps2()} />
                                                                                <Typography align="center" variant="h5">
                                                                                    Arraste e solte uma imagem aqui ou clique para adicionar
                                                                                </Typography>
                                                                            </div>
                                                                        )}

                                                                        <Grid item xs={12} style={{ padding: 40 }}>
                                                                            <TextField
                                                                                variant="standard"
                                                                                label="Descrição"
                                                                                fullWidth
                                                                                multiline
                                                                                minRows={1}
                                                                                value={descricaoImagem2}
                                                                                onChange={(e) => setDescricaoImagem2(e.target.value)}
                                                                                InputLabelProps={{ style: { color: isDark ? 'white' : 'inherit' } }}
                                                                                inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                            />
                                                                        </Grid>
                                                                    </CardContent>
                                                                </Card>
                                                            </Grid>

                                                            {/* BLOCO 3 */}
                                                            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                                                <Card>
                                                                    <CardContent style={{ position: "relative" }}>
                                                                        {(ordemCompra.caminho_imagem3 || imagemSelecionada3) && (
                                                                            <button
                                                                                onClick={() => handleRemoverImagem(3)}
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    top: 5,
                                                                                    right: 5,
                                                                                    background: "red",
                                                                                    color: "white",
                                                                                    border: "none",
                                                                                    borderRadius: "50%",
                                                                                    width: 28,
                                                                                    height: 28,
                                                                                    cursor: "pointer",
                                                                                    fontWeight: "bold"
                                                                                }}
                                                                            >
                                                                                X
                                                                            </button>
                                                                        )}

                                                                        {ordemCompra.caminho_imagem3 ? (
                                                                            <img
                                                                                src={ordemCompra.caminho_imagem3.replace(
                                                                                    "/home/wwgrup/ordensdecompra/",
                                                                                    "https://gruporosinetos.com/ocmidias/"
                                                                                )}
                                                                                alt="Imagem Selecionada 3"
                                                                                style={{ width: "100%", height: "auto", marginBottom: "10px" }}
                                                                            />
                                                                        ) : imagemSelecionada3 ? (
                                                                            <img
                                                                                src={URL.createObjectURL(imagemSelecionada3)}
                                                                                alt="Imagem Selecionada 3"
                                                                                style={{ width: "100%", height: "auto", marginBottom: "10px" }}
                                                                            />
                                                                        ) : (
                                                                            <div {...getRootProps3()} style={dropzoneStyles}>
                                                                                <input {...getInputProps3()} />
                                                                                <Typography align="center" variant="h5">
                                                                                    Arraste e solte uma imagem aqui ou clique para adicionar
                                                                                </Typography>
                                                                            </div>
                                                                        )}

                                                                        <Grid item xs={12} style={{ padding: 40 }}>
                                                                            <TextField
                                                                                variant="standard"
                                                                                label="Descrição"
                                                                                fullWidth
                                                                                multiline
                                                                                minRows={1}
                                                                                value={descricaoImagem3}
                                                                                onChange={(e) => setDescricaoImagem3(e.target.value)}
                                                                            />
                                                                        </Grid>
                                                                    </CardContent>
                                                                </Card>
                                                            </Grid>

                                                            {/* BLOCO 4 */}
                                                            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                                                <Card>
                                                                    <CardContent style={{ position: "relative" }}>
                                                                        {(ordemCompra.caminho_imagem4 || imagemSelecionada4) && (
                                                                            <button
                                                                                onClick={() => handleRemoverImagem(4)}
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    top: 5,
                                                                                    right: 5,
                                                                                    background: "red",
                                                                                    color: "white",
                                                                                    border: "none",
                                                                                    borderRadius: "50%",
                                                                                    width: 28,
                                                                                    height: 28,
                                                                                    cursor: "pointer",
                                                                                    fontWeight: "bold"
                                                                                }}
                                                                            >
                                                                                X
                                                                            </button>
                                                                        )}

                                                                        {ordemCompra.caminho_imagem4 ? (
                                                                            <img
                                                                                src={ordemCompra.caminho_imagem4.replace(
                                                                                    "/home/wwgrup/ordensdecompra/",
                                                                                    "https://gruporosinetos.com/ocmidias/"
                                                                                )}
                                                                                alt="Imagem Selecionada 4"
                                                                                style={{ width: "100%", height: "auto", marginBottom: "10px" }}
                                                                            />
                                                                        ) : imagemSelecionada4 ? (
                                                                            <img
                                                                                src={URL.createObjectURL(imagemSelecionada4)}
                                                                                alt="Imagem Selecionada 4"
                                                                                style={{ width: "100%", height: "auto", marginBottom: "10px" }}
                                                                            />
                                                                        ) : (
                                                                            <div {...getRootProps4()} style={dropzoneStyles}>
                                                                                <input {...getInputProps4()} />
                                                                                <Typography align="center" variant="h5">
                                                                                    Arraste e solte uma imagem aqui ou clique para adicionar
                                                                                </Typography>
                                                                            </div>
                                                                        )}

                                                                        <Grid item xs={12} style={{ padding: 40 }}>
                                                                            <TextField
                                                                                variant="standard"
                                                                                label="Descrição"
                                                                                fullWidth
                                                                                multiline
                                                                                minRows={1}
                                                                                value={descricaoImagem4}
                                                                                onChange={(e) => setDescricaoImagem4(e.target.value)}
                                                                            />
                                                                        </Grid>
                                                                    </CardContent>
                                                                </Card>
                                                            </Grid>

                                                        </Grid>
                                                        <Grid item xs={12}
                                                            container
                                                            alignItems="center"
                                                            justifyContent="center"
                                                        >

                                                            <Button onClick={(e) => atualizarArquivos()} variant="contained" color="primary">
                                                                Atualizar Imagens
                                                            </Button>
                                                        </Grid>


                                                    </Grid>

                                                    <Grid
                                                        value={value} index={2}
                                                        container
                                                        direction="row"
                                                        item xs={12}
                                                        alignItems="center"
                                                        justifyContent="center"
                                                    >
                                                    </Grid>

                                                    <Grid
                                                        value={value}
                                                        index={3}
                                                        container
                                                        direction="row"
                                                        item
                                                        xs={12}
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        spacing={2}
                                                        style={{ paddingTop: 30, backgroundColor: isDark ? '#121212' : 'white' }}
                                                    >

                                                        <Grid item xs={12}
                                                            container
                                                            alignItems="center"
                                                            justifyContent="center"
                                                        >

                                                            <Button onClick={(e) => atualizarDocumentos()} variant="contained" color="primary">
                                                                Atualizar Documentos
                                                            </Button>
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            xs={12}
                                                            container
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            spacing={4}
                                                            style={{ padding: 40 }}
                                                        >
                                                            {/* ===== ARQUIVO 1 ===== */}
                                                            <Grid item xs={8}>
                                                                <Card>
                                                                    <CardContent>
                                                                        {ordemCompra.caminho_arquivo1 && ordemCompra.caminho_arquivo1.trim() !== '' ? (
                                                                            <>
                                                                                <Typography variant="h5" sx={{ mb: 2 }}>
                                                                                    {"Descrição: " + ordemCompra.descricao_arquivo1}
                                                                                </Typography>
                                                                                <div
                                                                                    onClick={() => {
                                                                                        const link = ordemCompra.caminho_arquivo1.replaceAll(
                                                                                            "/home/wwgrup/ordensdecompra/",
                                                                                            "https://gruporosinetos.com/ocmidias/"
                                                                                        );
                                                                                        window.open(link, "_blank", "noopener,noreferrer");
                                                                                    }}
                                                                                    style={{
                                                                                        cursor: 'pointer',
                                                                                        display: 'flex',
                                                                                        justifyContent: 'center',
                                                                                        margin: 0,
                                                                                        width: '200px',
                                                                                        height: '200px',
                                                                                    }}
                                                                                >
                                                                                    <InsertDriveFileIcon style={{ fontSize: 48, color: "#1976d2" }} />
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                {arquivoSelecionado1 ? (
                                                                                    <div
                                                                                        onClick={() => window.open(URL.createObjectURL(arquivoSelecionado1), '_blank')}
                                                                                        style={{
                                                                                            cursor: 'pointer',
                                                                                            display: 'flex',
                                                                                            justifyContent: 'center',
                                                                                            margin: 0,
                                                                                            width: '200px',
                                                                                            height: '200px',
                                                                                        }}
                                                                                    >
                                                                                        <InsertDriveFileIcon style={{ fontSize: 48, color: "#1976d2" }} />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div {...getRootArquivoProps1()} style={dropzoneStyles}>
                                                                                        <input {...getInputArquivoProps1()} />
                                                                                        <Typography align="center" variant="h5">
                                                                                            Arraste e solte um arquivo aqui ou clique para adicionar
                                                                                        </Typography>
                                                                                    </div>
                                                                                )}
                                                                                <Grid item xs={12} style={{ padding: 40 }}>
                                                                                    <TextField
                                                                                        variant="standard"
                                                                                        name="descricaoArquivo1"
                                                                                        label="Descrição"
                                                                                        required
                                                                                        id="descricaoArquivo1"
                                                                                        value={descricaoArquivo1}
                                                                                        onChange={(e) => setDescricaoArquivo1(e.target.value)}
                                                                                        fullWidth
                                                                                        multiline
                                                                                        minRows={1}
                                                                                        InputLabelProps={{ style: { color: isDark ? 'white' : 'inherit' } }}
                                                                                        inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                                                    />
                                                                                </Grid>
                                                                            </>
                                                                        )}
                                                                    </CardContent>
                                                                </Card>
                                                            </Grid>

                                                            {/* ===== ARQUIVO 2 ===== */}
                                                            <Grid item xs={8}>
                                                                <Card>
                                                                    <CardContent>
                                                                        {ordemCompra.caminho_arquivo2 && ordemCompra.caminho_arquivo2.trim() !== '' ? (
                                                                            <>
                                                                                <Typography variant="h5" sx={{ mb: 2 }}>
                                                                                    {"Descrição: " + ordemCompra.descricao_arquivo2}
                                                                                </Typography>
                                                                                <div
                                                                                    onClick={() => {
                                                                                        const link = ordemCompra.caminho_arquivo2.replaceAll(
                                                                                            "/home/wwgrup/ordensdecompra/",
                                                                                            "https://gruporosinetos.com/ocmidias/"
                                                                                        );
                                                                                        window.open(link, "_blank", "noopener,noreferrer");
                                                                                    }}
                                                                                    style={{
                                                                                        cursor: 'pointer',
                                                                                        display: 'flex',
                                                                                        justifyContent: 'center',
                                                                                        margin: 0,
                                                                                        width: '200px',
                                                                                        height: '200px',
                                                                                    }}
                                                                                >
                                                                                    <InsertDriveFileIcon style={{ fontSize: 48, color: "#1976d2" }} />
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                {arquivoSelecionado2 ? (
                                                                                    <div
                                                                                        onClick={() => window.open(URL.createObjectURL(arquivoSelecionado2), '_blank')}
                                                                                        style={{
                                                                                            cursor: 'pointer',
                                                                                            display: 'flex',
                                                                                            justifyContent: 'center',
                                                                                            margin: 0,
                                                                                            width: '200px',
                                                                                            height: '200px',
                                                                                        }}
                                                                                    >
                                                                                        <InsertDriveFileIcon style={{ fontSize: 48, color: "#1976d2" }} />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div {...getRootArquivoProps2()} style={dropzoneStyles}>
                                                                                        <input {...getInputArquivoProps2()} />
                                                                                        <Typography align="center" variant="h5">
                                                                                            Arraste e solte um arquivo aqui ou clique para adicionar
                                                                                        </Typography>
                                                                                    </div>
                                                                                )}
                                                                                <Grid item xs={12} style={{ padding: 40 }}>
                                                                                    <TextField
                                                                                        variant="standard"
                                                                                        name="descricaoArquivo2"
                                                                                        label="Descrição"
                                                                                        required
                                                                                        id="descricaoArquivo2"
                                                                                        value={descricaoArquivo2}
                                                                                        onChange={(e) => setDescricaoArquivo2(e.target.value)}
                                                                                        fullWidth
                                                                                        multiline
                                                                                        minRows={1}
                                                                                    />
                                                                                </Grid>
                                                                            </>
                                                                        )}
                                                                    </CardContent>
                                                                </Card>
                                                            </Grid>

                                                            {/* ===== ARQUIVO 3 ===== */}
                                                            <Grid item xs={8}>
                                                                <Card>
                                                                    <CardContent>
                                                                        {ordemCompra.caminho_arquivo3 && ordemCompra.caminho_arquivo3.trim() !== '' ? (
                                                                            <>
                                                                                <Typography variant="h5" sx={{ mb: 2 }}>
                                                                                    {"Descrição: " + ordemCompra.descricao_arquivo3}
                                                                                </Typography>
                                                                                <div
                                                                                    onClick={() => {
                                                                                        const link = ordemCompra.caminho_arquivo3.replaceAll(
                                                                                            "/home/wwgrup/ordensdecompra/",
                                                                                            "https://gruporosinetos.com/ocmidias/"
                                                                                        );
                                                                                        window.open(link, "_blank", "noopener,noreferrer");
                                                                                    }}
                                                                                    style={{
                                                                                        cursor: 'pointer',
                                                                                        display: 'flex',
                                                                                        justifyContent: 'center',
                                                                                        margin: 0,
                                                                                        width: '200px',
                                                                                        height: '200px',
                                                                                    }}
                                                                                >
                                                                                    <InsertDriveFileIcon style={{ fontSize: 48, color: "#1976d2" }} />
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                {arquivoSelecionado3 ? (
                                                                                    <div
                                                                                        onClick={() => window.open(URL.createObjectURL(arquivoSelecionado3), '_blank')}
                                                                                        style={{
                                                                                            cursor: 'pointer',
                                                                                            display: 'flex',
                                                                                            justifyContent: 'center',
                                                                                            margin: 0,
                                                                                            width: '200px',
                                                                                            height: '200px',
                                                                                        }}
                                                                                    >
                                                                                        <InsertDriveFileIcon style={{ fontSize: 48, color: "#1976d2" }} />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div {...getRootArquivoProps3()} style={dropzoneStyles}>
                                                                                        <input {...getInputArquivoProps3()} />
                                                                                        <Typography align="center" variant="h5">
                                                                                            Arraste e solte um arquivo aqui ou clique para adicionar
                                                                                        </Typography>
                                                                                    </div>
                                                                                )}
                                                                                <Grid item xs={12} style={{ padding: 40 }}>
                                                                                    <TextField
                                                                                        variant="standard"
                                                                                        name="descricaoArquivo3"
                                                                                        label="Descrição"
                                                                                        required
                                                                                        id="descricaoArquivo3"
                                                                                        value={descricaoArquivo3}
                                                                                        onChange={(e) => setDescricaoArquivo3(e.target.value)}
                                                                                        fullWidth
                                                                                        multiline
                                                                                        minRows={1}
                                                                                    />
                                                                                </Grid>
                                                                            </>
                                                                        )}
                                                                    </CardContent>
                                                                </Card>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>



                                                </SwipeableViews>

                                            </Grid>



                                            <Grid value={value} index={1}
                                                container
                                                direction="row"
                                                item xs={12}
                                                alignItems="center"
                                                justifyContent="center"
                                                style={{ width: '100%', margin: 0, padding: 0 }}
                                            >


                                                <Grid
                                                    container
                                                    direction="row"
                                                    item xs={1}
                                                    alignItems="flex-start"
                                                    justifyContent="flex-start"
                                                    style={{ width: '100%', margin: 0, padding: 0 }}
                                                >
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        justifyContent="flex-start"
                                                        alignItems="flex-start"
                                                        item xs={12}
                                                        style={{ marginTop: 5 }}
                                                    >
                                                        {ordemCompra.ordem_servico ?
                                                            <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" item xs={6} style={{ marginTop: 5 }}>
                                                                <ClickAwayListener onClickAway={handleClickAwayListaOs}>
                                                                    <div>
                                                                        <IconButton
                                                                            aria-label="Requerimento de Itens"
                                                                            onClick={(e) => handleClickListaOs(e)}
                                                                            style={{ color: isDark ? 'white' : 'black', fontSize: 12 }}
                                                                        >
                                                                            <HelpOutlineIcon color="primary" />
                                                                            Requerimento de Itens (OS)
                                                                        </IconButton>

                                                                        <Popper open={openListaOs} anchorEl={anchorElListaOs} placement="right" style={{ zIndex: 1300 }}>
                                                                            <div
                                                                                style={{
                                                                                    backgroundColor: isDark ? '#1E1E1E' : 'white',
                                                                                    height: '80vh',
                                                                                    width: '80vw',
                                                                                    overflow: 'auto',
                                                                                    border: isDark ? '2px solid #444' : '2px solid black',
                                                                                    padding: 10,
                                                                                    color: isDark ? 'white' : 'black'
                                                                                }}
                                                                            >
                                                                                <Grid container direction="row" item xs={12} alignItems="center" justifyContent="center">
                                                                                    <Grid
                                                                                        container
                                                                                        direction="row"
                                                                                        item xs={12}
                                                                                        alignItems="flex-start"
                                                                                        justifyContent="flex-start"
                                                                                    >
                                                                                        <IconButton aria-label="Editar Lista de Requerimentos" style={{ color: 'green', fontSize: 12 }} onClick={(e) => handleClickEditarListaRequerimentos(e)}>
                                                                                            <EditIcon color='green' />
                                                                                            Editar Lista (OS)
                                                                                        </IconButton>
                                                                                        <IconButton
                                                                                            aria-label="Criar Orçamento"
                                                                                            style={{ color: '#1976d2', fontSize: 12, marginLeft: 10 }}
                                                                                            onClick={handleOrcamento}
                                                                                        >
                                                                                            <AddCircleOutlineIcon style={{ color: '#1976d2', marginRight: 5 }} />
                                                                                            Criar Orçamento
                                                                                        </IconButton>

                                                                                        <IconButton
                                                                                            aria-label="Finalizar O.C (Itens Requisitados em Estoque)"
                                                                                            style={{ color: '#1976d2', fontSize: 12, marginLeft: 10 }}
                                                                                            onClick={(e) => handleOpenFinalizar()}
                                                                                        >
                                                                                            <AddCircleOutlineIcon style={{ color: '#1276d6', marginRight: 5 }} />
                                                                                            Finalizar O.C (Itens Requisitados em Estoque)
                                                                                        </IconButton>
                                                                                    </Grid>


                                                                                    {ordemCompra.ordem_servico?.itens_pre_requerimento && (
                                                                                        <DataGrid
                                                                                            rows={ordemCompra.ordem_servico.itens_pre_requerimento}
                                                                                            getRowId={(row) => row.id_item_requerimento}
                                                                                            columns={columnsItensDataGrid}
                                                                                            disableColumnResize={false}
                                                                                            rowHeight={30}
                                                                                            autoHeight={false}
                                                                                        />
                                                                                    )}
                                                                                </Grid>
                                                                            </div>
                                                                        </Popper>
                                                                    </div>
                                                                </ClickAwayListener>
                                                            </Grid>
                                                            :
                                                            <Grid
                                                                container
                                                                direction="row"
                                                                justifyContent="flex-start"
                                                                align="flex-start"
                                                                item xs={6}
                                                                style={{ marginTop: 5 }}
                                                            >
                                                                <IconButton
                                                                    aria-label="Requerimento de Itens"
                                                                    style={{ color: isDark ? 'white' : 'black', fontSize: 12 }}
                                                                    onClick={handleClickPopover5}
                                                                >
                                                                    <HelpOutlineIcon color="primary" />
                                                                    Requerimento de Itens (OC)
                                                                </IconButton>

                                                                <Popover
                                                                    open={openPopover5}
                                                                    anchorEl={anchorElPopover5}
                                                                    onClose={handleClosePopover5}
                                                                    anchorOrigin={{
                                                                        vertical: 'center',
                                                                        horizontal: 'right',
                                                                    }}
                                                                    transformOrigin={{
                                                                        vertical: 'center',
                                                                        horizontal: 'left',
                                                                    }}
                                                                    PaperProps={{
                                                                        style: {
                                                                            backgroundColor: isDark ? '#1E1E1E' : 'white',
                                                                            height: '80vh',
                                                                            width: '80vw',
                                                                            overflow: 'auto',
                                                                            border: isDark ? '2px solid #444' : '2px solid black',
                                                                            padding: 10,
                                                                            color: isDark ? 'white' : 'black'
                                                                        },
                                                                    }}
                                                                >
                                                                    <Grid
                                                                        container
                                                                        direction="row"
                                                                        item xs={12}
                                                                        alignItems="flex-start"
                                                                        justifyContent="flex-start"
                                                                    >
                                                                        <IconButton
                                                                            aria-label="Editar Lista de Requerimentos"
                                                                            style={{ color: 'green', fontSize: 12 }}
                                                                            onClick={(e) => handleClickEditarListaRequerimentos(e)}
                                                                        >
                                                                            <EditIcon color="success" />
                                                                            Editar Lista (OC)
                                                                        </IconButton>
                                                                        <IconButton
                                                                            aria-label="Criar Orçamento"
                                                                            style={{ color: '#1976d2', fontSize: 12, marginLeft: 10 }}
                                                                            onClick={handleOrcamento}
                                                                        >
                                                                            <AddCircleOutlineIcon style={{ color: '#1976d2', marginRight: 5 }} />
                                                                            Criar Orçamento
                                                                        </IconButton>
                                                                    </Grid>

                                                                    <Grid
                                                                        container
                                                                        direction="row"
                                                                        item xs={12}
                                                                        alignItems="center"
                                                                        justifyContent="center"
                                                                    >
                                                                        {ordemCompra.itens_pre_requerimento && (
                                                                            <DataGrid
                                                                                rows={ordemCompra.itens_pre_requerimento}
                                                                                getRowId={(row) => row.id_item_requerimento}
                                                                                columns={columnsItensDataGrid}
                                                                                disableColumnResize={false}
                                                                                rowHeight={30}
                                                                                autoHeight={false}
                                                                            />
                                                                        )}
                                                                    </Grid>
                                                                </Popover>
                                                            </Grid>
                                                        }
                                                    </Grid>
                                                </Grid>


                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="flex-end"
                                                    alignItems="center"
                                                    item xs={11}
                                                >


                                                    <Grid
                                                        container
                                                        direction="row"
                                                        justifyContent="flex-end"
                                                        alignItems="center"
                                                        item xs={12}
                                                    >

                                                        <Button
                                                            style={{ margin: 5 }}
                                                            variant="contained"
                                                            color="primary"
                                                            startIcon={<AddIcon />}
                                                            onClick={() => novaPreCotacao()} // Substitua handleNovoOrcamento pelo seu manipulador de evento
                                                        >
                                                            Orçamento
                                                        </Button>
                                                    </Grid>

                                                </Grid>

                                                {preCotacoes && (
                                                    <>
                                                        <DataGrid
                                                            pagination
                                                            checkboxSelection
                                                            rows={preCotacoes}
                                                            getRowId={(row) => row.id_pre_cotacao}
                                                            columns={columnsPreCotacaoDataGrid}
                                                            disableColumnResize={false}
                                                            onCellClick={handleCellClick}
                                                            onRowClick={handleRowClick}
                                                            components={{
                                                                Toolbar: CustomToolbar,
                                                            }}
                                                        />
                                                    </>
                                                )}





                                                {ordemCompra.status === 0 && idUsuarioLogado === idUsuarioCriador && (
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        justifyContent="flex-start"
                                                        alignItems="center"
                                                        item xs={12}
                                                    >
                                                        <Button style={{ margin: 5, marginTop: 5 }}
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={finalizarParaAutorizar}
                                                        > Finalizar para Autorização  </Button>
                                                    </Grid>
                                                )}



                                            </Grid>


                                            <Grid
                                                value={value} index={2}
                                                container
                                                direction="row"
                                                item xs={12}
                                                alignItems="center"
                                                justifyContent="center"
                                                style={{
                                                    backgroundColor: isDark ? '#121212' : 'white',
                                                    margin: 0,
                                                    padding: 0,
                                                }}
                                            >


                                                <AnaliseOrcamentaria
                                                    ordemCompra={ordemCompra}
                                                    columnsItensDataGrid={columnsItensDataGrid}
                                                    isSolicitante={isSolicitante}
                                                    isSupervisor={isSupervisor}
                                                    handleClickMotivoEscolha={handleClickMotivoEscolha}
                                                    autorizou={autorizou}
                                                    handleOpenAutorizar={handleOpenAutorizar}
                                                    telaCheia={telaCheia}
                                                    handleToggleTelaCheia={handleToggleTelaCheia}
                                                    objetosAnalise={objetosAnalise}
                                                    columnsAnalise={columnsAnalise}
                                                    infoOrdem={infoOrdem}
                                                    currencyFormatter={currencyFormatter}
                                                    valorTotalGlobal={valorTotalGlobal}
                                                    valorFreteGlobal={valorFreteGlobal}
                                                    isDark={isDark}
                                                />

                                            </Grid>



                                            <Grid
                                                value={value} index={3}
                                                container
                                                direction="row"
                                                item xs={12}
                                                alignItems="center"
                                                justifyContent="center"
                                            >

                                                <Grid item xs={12}
                                                    container
                                                    alignItems="center"
                                                    justifyContent="center"
                                                >

                                                    <Button onClick={(e) => atualizarCompras()} variant="contained" color="primary">
                                                        Atualizar Compras
                                                    </Button>
                                                </Grid>


                                                <Grid item xs={12}
                                                    container
                                                    alignItems="center"
                                                    justifyContent="center"
                                                >

                                                    {ordemCompra.status >= 3 && preCotacoes &&
                                                        <>
                                                            < DataGrid
                                                                pagination
                                                                checkboxSelection
                                                                rows={filtrarPreCotacoes(preCotacoes)}
                                                                getRowId={(row) => row.id_pre_cotacao}
                                                                columns={columnsComprasDataGrid}
                                                                disableColumnResize={false}
                                                                onCellClick={handleCellClick}
                                                                onRowClick={handleRowClick}
                                                                components={{
                                                                    Toolbar: CustomToolbar,
                                                                }}
                                                            />
                                                        </>
                                                    }
                                                </Grid>

                                            </Grid>

                                            <Grid
                                                value={value} index={4}
                                                container
                                                direction="row"
                                                item xs={12}
                                                alignItems="center"
                                                justifyContent="center"
                                            >


                                                <Grid container spacing={2}
                                                    item xs={12}
                                                    style={{ padding: 30 }}
                                                    rowSpacing={2}>
                                                    {ordemCompra.procedimentos_execucao?.map((procedimento_analise, index) => (
                                                        <Grid item xs={3} key={index}>
                                                            {/* xs=12 para dispositivos pequenos, sm=6 para médios, md=4 para grandes, lg=3 para extra grandes */}
                                                            <Card style={{ borderRadius: '10px', border: '1px solid #e0e0e0', boxShadow: '0 10px 20px rgba(0, 0, 0, 0.2)', marginBottom: '16px' }}>
                                                                <CardContent>
                                                                    <Link
                                                                        target="_blank"
                                                                        to={`/gestao/operacional/procedimentos/vizualizar/${procedimento_analise.procedimento.id_procedimento}`}
                                                                    >
                                                                        <Typography variant="h7">{procedimento_analise.procedimento.nome}</Typography>
                                                                    </Link>
                                                                    <br /> <br /> <br />
                                                                    <Typography variant="h8">{"Status: " + (procedimento_analise.status === 0 ? "Não Executado" : "Concluído")}</Typography>
                                                                    <br />
                                                                    {
                                                                        procedimento_analise.status === 1 ?
                                                                            <Typography variant="h8">{(procedimento_analise.resultado === 0 ? "Resultado: Falha" : "Resultado: Sucesso")}</Typography>
                                                                            :
                                                                            <Typography variant="h8"></Typography>

                                                                    }
                                                                    <br />
                                                                    {
                                                                        procedimento_analise.status === 1 ?
                                                                            <Typography variant="h8">
                                                                                {`Executado por ${procedimento_analise.usuario_executor.nome_amigavel}`} <br />
                                                                                {`às ${moment(procedimento_analise.data_hora_execucao).format('HH:mm:ss DD/MM/YYYY')}`}
                                                                            </Typography> :
                                                                            <Typography variant="h8"></Typography>

                                                                    }
                                                                    <br /> <br />
                                                                    <Typography variant="h8">{(procedimento_analise.procedimento.obrigatorio === 1 ? "Procedimento Obrigatório" : "Procedimento Opcional")}</Typography>
                                                                    <br /> <br />
                                                                    {
                                                                        procedimento_analise.status === 0 ?
                                                                            <ColorButtonBlue variant="contained" color="primary"
                                                                                onClick={(event) => handleClickAtualizarProcedimento(procedimento_analise)}
                                                                            >
                                                                                Atualizar
                                                                            </ColorButtonBlue>
                                                                            :
                                                                            <ColorButtonGreen variant="contained" color="primary"
                                                                                onClick={(event) => handleClickVizualizarProcedimento(procedimento_analise.id_procedimento_execucao)}
                                                                            >
                                                                                Vizualizar
                                                                            </ColorButtonGreen>
                                                                    }

                                                                </CardContent>
                                                            </Card>

                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </Grid>




                                        </SwipeableViews>
                                    </Grid>
                                </Grid>







                            </div>
                        }


                    </div>


                    <Dialog open={open}
                        disableBackdropClick>
                        <DialogTitle>Processando Solicitação, Aguarde!</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {isLoading ? (
                                    <CircularProgress /> // Indicador de carregamento
                                ) : (
                                    'Por favor, aguarde enquanto sua solicitação está sendo processada...'
                                )}
                            </DialogContentText>
                        </DialogContent>



                    </Dialog>


                    <Dialog
                        open={openAutorizar}
                        onClose={() => setOpenAutorizar(false)}
                        aria-labelledby="autorize-dialog"
                    >
                        <DialogTitle id="autorize-dialog">{"Autorizar Ordem de Compra"}</DialogTitle>
                        <DialogContent>{"Digite o Código do Aplicativo Autenticador"}</DialogContent>
                        <Grid item xs={12} style={{ padding: 5 }}>
                            <TextField
                                id="codigoValidacao"
                                variant="standard"
                                name="codigoValidacao"
                                fullWidth
                                label="Código de Validação"
                                value={codigoValidacao}
                                onChange={(e) => setCodigoValidacao(e.target.value)}
                            />

                        </Grid>
                        <DialogActions>
                            <Button
                                variant="contained"
                                onClick={() => setOpenAutorizar(false)}
                                color="secondary"
                            >
                                Cancelar
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    setOpen(false);
                                    autorizar();
                                }}
                                color="default"
                            >
                                Autorizar
                            </Button>
                        </DialogActions>
                    </Dialog>


                    <Dialog open={openDialogMotivo} onClose={handleCloseDialogMotivo} PaperProps={{ style: { maxWidth: '1000px', minWidth: '500px' } }}>
                        <DialogTitle>Finalizar Ánalise Orçamentária</DialogTitle>
                        <DialogContent>
                            <Grid
                                direction={"row"}
                                item xs={12}
                                container
                                alignItems={'center'}
                                justifyContent={'center'}
                                spacing={3}
                            >

                                <Grid
                                    item xs={12}
                                    style={{ margin: 2, padding: 2 }}
                                >
                                    <TextField
                                        label="Motivo"
                                        variant="outlined"
                                        fullWidth
                                        minRows={3}
                                        value={motivoEscolha}
                                        onChange={(e) => setMotivoEscolha(e.target.value)}
                                    />
                                </Grid>
                                <Grid
                                    item xs={12}
                                >


                                    <Button style={{ margin: 20, padding: 20 }} variant="contained" color="primary" onClick={escolher}>
                                        Finalizar
                                    </Button>
                                </Grid>



                            </Grid>

                        </DialogContent>
                    </Dialog>

                    <Snackbar
                        open={openAtualizando}
                        autoHideDuration={1500}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    >
                        <MuiAlert elevation={6} variant="filled"  >
                            Atualizando...
                        </MuiAlert>
                    </Snackbar>

                    <CustomDialog cotacao={cotacaoNovaTarefa} />
                    {isOpenResposta && <CustomDialogResposta tarefa={tarefaResponder} />}




                    <Dialog open={openDialogNovaCotacao} onClose={handleCloseDialogNovaCotacao} PaperProps={{ style: { maxWidth: '600px', minWidth: '300px' } }}>
                        <DialogTitle>Inserir Novo Orçamento</DialogTitle>
                        <DialogContent>
                            <Grid
                                direction={"row"}
                                item xs={12}
                                container
                                alignItems={'center'}
                                justifyContent={'center'}
                                spacing={3}
                            >
                                <CadastrarPreCotacao idOrdemCompra={idOrdemCompra} handleCloseDialogNovaCotacao={handleCloseDialogNovaCotacao} />

                            </Grid>

                        </DialogContent>
                    </Dialog>



                    <Dialog
                        open={openCancelar}
                        onClose={() => setOpenCancelar(false)}
                        aria-labelledby="autorize-dialog"
                    >
                        <DialogTitle id="autorize-dialog">{"Cancelar Ordem de Compra"}</DialogTitle>
                        <Grid item xs={12} style={{ padding: 5 }}>
                            <TextField
                                id="motivoCancelamento"
                                variant="standard"
                                name="motivoCancelamento"
                                fullWidth
                                label="Motivo"
                                value={motivoCancelamento}
                                minRows={3}
                                multiline
                                onChange={(e) => setMotivoCancelamento(e.target.value)}
                            />

                        </Grid>
                        <DialogActions>
                            <Button
                                variant="contained"
                                onClick={() => setOpenCancelar(false)}
                                color="secondary"
                            >
                                Desistir
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    cancelarOrdemCompra();
                                }}
                                color="default"
                            >
                                Cancelar
                            </Button>
                        </DialogActions>
                    </Dialog>




                    <Dialog
                        open={openFinalizar}
                        onClose={() => handleCloseFinalizar()}
                        aria-labelledby="autorize-dialog"
                    >
                        <DialogTitle id="autorize-dialog">{"Finalizar Ordem de Compra"}</DialogTitle>
                        <Grid item xs={12} style={{ padding: 5 }}>
                            <TextField
                                id="motivoFinalizar"
                                variant="standard"
                                name="motivoFinalizar"
                                fullWidth
                                label="Motivo"
                                value={motivoFinalizar}
                                minRows={3}
                                multiline
                                onChange={(e) => setMotivoFinalizar(e.target.value)}
                            />

                        </Grid>
                        <DialogActions>
                            <Button
                                variant="contained"
                                onClick={() => handleCloseFinalizar()}
                                color="secondary"
                            >
                                Desistir
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    finalizarOrdemCompra();
                                }}
                                color="default"
                            >
                                Finalizar
                            </Button>
                        </DialogActions>
                    </Dialog>





                    {
                        !loading && (
                            <>
                                {/* Fundo translúcido atrás do Popover */}
                                {Boolean(anchorElListaItens) && (
                                    <div
                                        onClick={handleCloseListaItens} // fecha ao clicar fora
                                        style={{
                                            position: 'fixed',
                                            top: 0,
                                            left: 0,
                                            width: '100vw',
                                            height: '100vh',
                                            backgroundColor: 'rgba(0, 0, 0, 0.4)', // cinza translúcido
                                            zIndex: 1300, // abaixo do popover
                                        }}
                                    />
                                )}

                                <Popover
                                    open={Boolean(anchorElListaItens)}
                                    onClose={handleCloseListaItens}
                                    anchorReference="anchorPosition"
                                    anchorPosition={{
                                        top: window.innerHeight / 2,
                                        left: window.innerWidth / 2,
                                    }}
                                    transformOrigin={{
                                        vertical: 'center',
                                        horizontal: 'center',
                                    }}
                                    PaperProps={{
                                        sx: {
                                            position: 'fixed',
                                            top: '50% !important',
                                            left: '50% !important',
                                            transform: 'translate(-50%, -50%) !important',
                                            border: '3px solid black', // borda preta e grossa
                                            borderRadius: '12px', // bordas arredondadas
                                            boxShadow: 10, // sombra sutil para destacar
                                            zIndex: 1400, // acima do overlay
                                        },
                                    }}
                                >
                                    <div
                                        style={{
                                            padding: 1,
                                            backgroundColor: isDark ? '#121212' : 'white',
                                            minWidth: '98vw',
                                            minHeight: '98vh',
                                            maxWidth: '98vw',
                                            maxHeight: '98vh',
                                        }}
                                    >
                                        <RequerimentoInsumos flag={2} ordemServicoIn={ordemServicoSelecionada} />
                                    </div>
                                </Popover>
                            </>
                        )
                    }

                    <Backdrop
                        open={loadingAtualizarCompras}
                        sx={{ color: '#fff', zIndex: 9999 }}
                    >
                        <div style={{
                            background: "white",
                            padding: "25px 40px",
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "15px",
                            color: "#333",
                            fontSize: "18px",
                            fontWeight: "500"
                        }}>
                            <CircularProgress />
                            <div>Processando, aguarde...</div>
                        </div>
                    </Backdrop>

                </div >
            </ThemeProviderV5>
        </ThemeProviderV4>
    );
}


